var items = {
  "block.minecraft.acacia_button": ".atkaciia batke",
  "block.minecraft.acacia_door": ".atkaciia vrogai",
  "block.minecraft.acacia_fence": ".atkaciia garbi'u",
  "block.minecraft.acacia_fence_gate": ".atkaciia garbimvrogai",
  "block.minecraft.acacia_hanging_sign": ".atkaciia ke dandu lertapla",
  "block.minecraft.acacia_leaves": ".atkaciia pezli",
  "block.minecraft.acacia_log": ".atkaciia stani",
  "block.minecraft.acacia_planks": ".atkaciia tanbo",
  "block.minecraft.acacia_pressure_plate": ".atkaciia danrytapla",
  "block.minecraft.acacia_sapling": ".atkaciia ciftricu",
  "block.minecraft.acacia_shelf": ".atkaciia kajna",
  "block.minecraft.acacia_sign": ".atkaciia lertapla",
  "block.minecraft.acacia_slab": ".atkaciia xabybli",
  "block.minecraft.acacia_stairs": ".atkaciia serti",
  "block.minecraft.acacia_trapdoor": ".atkaciia lolvrogai",
  "block.minecraft.acacia_wall_hanging_sign": "bitmu ke .atkaciia ke dandu lertapla",
  "block.minecraft.acacia_wall_sign": ".atkaciia ke bitmu lertapla",
  "block.minecraft.acacia_wood": "atkaciia mudri",
  "block.minecraft.activator_rail": "actigau tertrene",
  "block.minecraft.air": "vacri",
  "block.minecraft.allium": "citsluni",
  "block.minecraft.amethyst_block": ".amtisti bliku",
  "block.minecraft.amethyst_cluster": ".amtisti girzu",
  "block.minecraft.ancient_debris": "tcepru spisa",
  "block.minecraft.andesite": "rokcrande'i",
  "block.minecraft.andesite_slab": "rokcrande'i xabybli",
  "block.minecraft.andesite_stairs": "rokcrande'i serti",
  "block.minecraft.andesite_wall": "rokcrande'i bitmu",
  "block.minecraft.anvil": "jimda'izbe",
  "block.minecraft.attached_melon_stem": "seljo'e ke guzme stani",
  "block.minecraft.attached_pumpkin_stem": "seljo'e ke guzmrkukurbita stani",
  "block.minecraft.azalea": "ricnrododendro",
  "block.minecraft.azalea_leaves": "ricnrododendro pezli",
  "block.minecraft.azure_bluet": "cmablabyxrula",
  "block.minecraft.bamboo": "bambu",
  "block.minecraft.bamboo_block": "bambu bliku",
  "block.minecraft.bamboo_button": "bambu batke",
  "block.minecraft.bamboo_door": "bambu vrogai",
  "block.minecraft.bamboo_fence": "bambu garbi'u",
  "block.minecraft.bamboo_fence_gate": "bambu garbimvrogai",
  "block.minecraft.bamboo_hanging_sign": "bambu ke dandu lertapla",
  "block.minecraft.bamboo_mosaic": "morna ke bambu bliku",
  "block.minecraft.bamboo_mosaic_slab": "morna bambu xabybli",
  "block.minecraft.bamboo_mosaic_stairs": "morna ke bambu serti",
  "block.minecraft.bamboo_planks": "bambu tanbo",
  "block.minecraft.bamboo_pressure_plate": "bambu danrytapla",
  "block.minecraft.bamboo_sapling": "cifybambu",
  "block.minecraft.bamboo_shelf": "bambu kajna",
  "block.minecraft.bamboo_sign": "bambu lertapla",
  "block.minecraft.bamboo_slab": "bambu xabybli",
  "block.minecraft.bamboo_stairs": "bambu serti",
  "block.minecraft.bamboo_trapdoor": "bambu lolvrogai",
  "block.minecraft.bamboo_wall_hanging_sign": "bitmu ke bambu ke dandu lertapla",
  "block.minecraft.bamboo_wall_sign": "bambu ke bitmu lertapla",
  "block.minecraft.banner.base.black": "xekri lanci",
  "block.minecraft.banner.base.blue": "blanu lanci",
  "block.minecraft.banner.base.brown": "bunre lanci",
  "block.minecraft.banner.base.cyan": "cicna lanci",
  "block.minecraft.banner.base.gray": "grusi lanci",
  "block.minecraft.banner.base.green": "crino lanci",
  "block.minecraft.banner.base.light_blue": "labybla lanci",
  "block.minecraft.banner.base.light_gray": "labyrus lanci",
  "block.minecraft.banner.base.lime": "labri'o lanci",
  "block.minecraft.banner.base.magenta": "nuki lanci",
  "block.minecraft.banner.base.orange": "narju lanci",
  "block.minecraft.banner.base.pink": "penka lanci",
  "block.minecraft.banner.base.purple": "zirpu lanci",
  "block.minecraft.banner.base.red": "xunre lanci",
  "block.minecraft.banner.base.white": "blabi lanci",
  "block.minecraft.banner.base.yellow": "pelxu lanci",
  "block.minecraft.banner.border.black": "xekri kurgreku",
  "block.minecraft.banner.border.blue": "blanu kurgreku",
  "block.minecraft.banner.border.brown": "bunre kurgreku",
  "block.minecraft.banner.border.cyan": "cicna kurgreku",
  "block.minecraft.banner.border.gray": "grusi kurgreku",
  "block.minecraft.banner.border.green": "crino kurgreku",
  "block.minecraft.banner.border.light_blue": "labybla kurgreku",
  "block.minecraft.banner.border.light_gray": "labgrusi kurgreku",
  "block.minecraft.banner.border.lime": "labri'o kurgreku",
  "block.minecraft.banner.border.magenta": "nukni kurgreku",
  "block.minecraft.banner.border.orange": "narju kurgreku",
  "block.minecraft.banner.border.pink": "penka kurgreku",
  "block.minecraft.banner.border.purple": "zirpu kurgreku",
  "block.minecraft.banner.border.red": "xunre korbi",
  "block.minecraft.banner.border.white": "blabi kurgreku",
  "block.minecraft.banner.border.yellow": "pelxu kurgreku",
  "block.minecraft.banner.bricks.black": "morna lo'e xekri bliku",
  "block.minecraft.banner.bricks.blue": "morna lo'e blanu bliku",
  "block.minecraft.banner.bricks.brown": "morna lo'e bunre bliku",
  "block.minecraft.banner.bricks.cyan": "morna lo'e cicna bliku",
  "block.minecraft.banner.bricks.gray": "morna lo'e grusi bliku",
  "block.minecraft.banner.bricks.green": "morna lo'e crino bliku",
  "block.minecraft.banner.bricks.light_blue": "morna lo'e labybla bliku",
  "block.minecraft.banner.bricks.light_gray": "morna lo'e labgrusi bliku",
  "block.minecraft.banner.bricks.lime": "labri'o ke bliku morna",
  "block.minecraft.banner.bricks.magenta": "morna lo'e nukni bliku",
  "block.minecraft.banner.bricks.orange": "morna lo'e narju bliku",
  "block.minecraft.banner.bricks.pink": "morna lo'e penka bliku",
  "block.minecraft.banner.bricks.purple": "morna lo'e zirpu bliku",
  "block.minecraft.banner.bricks.red": "morna lo'e xunre bliku",
  "block.minecraft.banner.bricks.white": "morna lo'e blabi bliku",
  "block.minecraft.banner.bricks.yellow": "morna lo'e pelxu bliku",
  "block.minecraft.banner.circle.black": "xekri cukla",
  "block.minecraft.banner.circle.blue": "blanu cukla",
  "block.minecraft.banner.circle.brown": "bunre cukla",
  "block.minecraft.banner.circle.cyan": "cicna cukla",
  "block.minecraft.banner.circle.gray": "grusi cukla",
  "block.minecraft.banner.circle.green": "crino cukla",
  "block.minecraft.banner.circle.light_blue": "labybla cukla",
  "block.minecraft.banner.circle.light_gray": "labgrusi cukla",
  "block.minecraft.banner.circle.lime": "labri'o cukla",
  "block.minecraft.banner.circle.magenta": "nukni cukla",
  "block.minecraft.banner.circle.orange": "narju cukla",
  "block.minecraft.banner.circle.pink": "penka cukla",
  "block.minecraft.banner.circle.purple": "zirpu cukla",
  "block.minecraft.banner.circle.red": "xunre cukla",
  "block.minecraft.banner.circle.white": "blabi cukla",
  "block.minecraft.banner.circle.yellow": "pelxu cukla",
  "block.minecraft.banner.creeper.black": "lo xekri ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.blue": "lo blanu ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.brown": "lo bunre ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.cyan": "lo cicna ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.gray": "lo grusi ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.green": "lo crino ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.light_blue": "lo labybla ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.light_gray": "lo labyrus ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.lime": "labri'o ke ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.magenta": "lo nukni ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.orange": "lo narju ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.pink": "lo xunblabi ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.purple": "lo zirpu ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.red": "lo xunre ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.white": "lo blabi ri'orfrupo'a flira",
  "block.minecraft.banner.creeper.yellow": "lo pelxu ri'orfrupo'a flira",
  "block.minecraft.banner.cross.black": "xekri salpo kuctai",
  "block.minecraft.banner.cross.blue": "blanu salpo kuctai",
  "block.minecraft.banner.cross.brown": "bunre salpo kuctai",
  "block.minecraft.banner.cross.cyan": "cicna salpo kuctai",
  "block.minecraft.banner.cross.gray": "grusi salpo kuctai",
  "block.minecraft.banner.cross.green": "crino salpo kuctai",
  "block.minecraft.banner.cross.light_blue": "labybla salpo kuctai",
  "block.minecraft.banner.cross.light_gray": "labgrusi salpo kuctai",
  "block.minecraft.banner.cross.lime": "labri'o ke salpo kuctai",
  "block.minecraft.banner.cross.magenta": "nukni salpo kuctai",
  "block.minecraft.banner.cross.orange": "narju salpo kuctai",
  "block.minecraft.banner.cross.pink": "penka salpo kuctai",
  "block.minecraft.banner.cross.purple": "zirpu salpo kuctai",
  "block.minecraft.banner.cross.red": "xunre salpo kuctai",
  "block.minecraft.banner.cross.white": "blabi salpo kuctai",
  "block.minecraft.banner.cross.yellow": "pelxu salpo kuctai",
  "block.minecraft.banner.curly_border.black": "morna lo'e xekri korbyrufsu",
  "block.minecraft.banner.curly_border.blue": "morna lo'e blanu korbyrufsu",
  "block.minecraft.banner.curly_border.brown": "morna lo'e bunre korbyrufsu",
  "block.minecraft.banner.curly_border.cyan": "morna lo'e cicna korbyrufsu",
  "block.minecraft.banner.curly_border.gray": "morna lo'e grusi korbyrufsu",
  "block.minecraft.banner.curly_border.green": "morna lo'e crino korbyrufsu",
  "block.minecraft.banner.curly_border.light_blue": "morna lo'e labybla korbyrufsu",
  "block.minecraft.banner.curly_border.light_gray": "morna lo'e labgrusi korbyrufsu",
  "block.minecraft.banner.curly_border.lime": "pelri'o ke rufkoi morna",
  "block.minecraft.banner.curly_border.magenta": "morna lo'e nukni korbyrufsu",
  "block.minecraft.banner.curly_border.orange": "morna lo'e narju korbyrufsu",
  "block.minecraft.banner.curly_border.pink": "morna lo'e penka korbyrufsu",
  "block.minecraft.banner.curly_border.purple": "morna lo'e zirpu korbyrufsu",
  "block.minecraft.banner.curly_border.red": "morna lo'e xunre korbyrufsu",
  "block.minecraft.banner.curly_border.white": "morna lo'e blabi korbyrufsu",
  "block.minecraft.banner.curly_border.yellow": "morna lo'e pelxu korbyrufsu",
  "block.minecraft.banner.diagonal_left.black": "xekri xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.blue": "blanu xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.brown": "bunre xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.cyan": "cicna xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.gray": "grusi xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.green": "crino xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.light_blue": "labybla xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.light_gray": "labgrusi xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.lime": "labri'o ke xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.magenta": "nukni xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.orange": "narju xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.pink": "penka xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.purple": "zirpu xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.red": "xunre xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.white": "blabi xadba zulsa'osri",
  "block.minecraft.banner.diagonal_left.yellow": "pelxu xadba zulsa'osri",
  "block.minecraft.banner.diagonal_right.black": "xekri xabsa'osri",
  "block.minecraft.banner.diagonal_right.blue": "blanu xabsa'osri",
  "block.minecraft.banner.diagonal_right.brown": "bunre xabsa'osri",
  "block.minecraft.banner.diagonal_right.cyan": "cicna xabsa'osri",
  "block.minecraft.banner.diagonal_right.gray": "grusi xabsa'osri",
  "block.minecraft.banner.diagonal_right.green": "crino xabsa'osri",
  "block.minecraft.banner.diagonal_right.light_blue": "labybla xabsa'osri",
  "block.minecraft.banner.diagonal_right.light_gray": "labgrusi xabsa'osri",
  "block.minecraft.banner.diagonal_right.lime": "labri'o xabsa'osri",
  "block.minecraft.banner.diagonal_right.magenta": "nukni xabsa'osri",
  "block.minecraft.banner.diagonal_right.orange": "narju xabsa'osri",
  "block.minecraft.banner.diagonal_right.pink": "penka xabsa'osri",
  "block.minecraft.banner.diagonal_right.purple": "zirpu xabsa'osri",
  "block.minecraft.banner.diagonal_right.red": "xunre xabsa'osri",
  "block.minecraft.banner.diagonal_right.white": "blabi xabsa'osri",
  "block.minecraft.banner.diagonal_right.yellow": "pelxu xabsa'osri",
  "block.minecraft.banner.diagonal_up_left.black": "xekri pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.blue": "blanu pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.brown": "bunre pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.cyan": "cicna pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.gray": "grusi pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.green": "crino pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.light_blue": "labybla pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.light_gray": "labgrusi pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.lime": "labri'o ke pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.magenta": "nukni pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.orange": "narju pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.pink": "penka pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.purple": "zirpu pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.red": "xunre pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.white": "blabi pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_left.yellow": "pelxu pritu dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.black": "xekri zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.blue": "blanu zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.brown": "bunre zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.cyan": "cicna zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.gray": "grusi zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.green": "crino zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.light_blue": "labybla zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.light_gray": "labgrusi zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.lime": "labri'o ke zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.magenta": "nukni zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.orange": "narju zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.pink": "penka zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.purple": "zirpu zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.red": "xunre zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.white": "blabi zunle dziraipau cibjgatai",
  "block.minecraft.banner.diagonal_up_right.yellow": "pelxu zunle dziraipau cibjgatai",
  "block.minecraft.banner.flow.black": "xekri sarlu",
  "block.minecraft.banner.flow.blue": "blanu sarlu",
  "block.minecraft.banner.flow.brown": "bunre sarlu",
  "block.minecraft.banner.flow.cyan": "cicna sarlu",
  "block.minecraft.banner.flow.gray": "grusi sarlu",
  "block.minecraft.banner.flow.green": "crino sarlu",
  "block.minecraft.banner.flow.light_blue": "labybla sarlu",
  "block.minecraft.banner.flow.light_gray": "labgrusi sarlu",
  "block.minecraft.banner.flow.lime": "labri'o sarlu",
  "block.minecraft.banner.flow.magenta": "nukni sarlu",
  "block.minecraft.banner.flow.orange": "narju sarlu",
  "block.minecraft.banner.flow.pink": "penka sarlu",
  "block.minecraft.banner.flow.purple": "zirpu sarlu",
  "block.minecraft.banner.flow.red": "xunre sarlu",
  "block.minecraft.banner.flow.white": "blabi sarlu",
  "block.minecraft.banner.flow.yellow": "pelxu sarlu",
  "block.minecraft.banner.flower.black": "xekri xrula tarmi",
  "block.minecraft.banner.flower.blue": "blanu xrula tarmi",
  "block.minecraft.banner.flower.brown": "bunre xrula tarmi",
  "block.minecraft.banner.flower.cyan": "cicna xrula tarmi",
  "block.minecraft.banner.flower.gray": "grusi xrula tarmi",
  "block.minecraft.banner.flower.green": "crino xrula tarmi",
  "block.minecraft.banner.flower.light_blue": "labybla xrula tarmi",
  "block.minecraft.banner.flower.light_gray": "labyrus xrula tarmi",
  "block.minecraft.banner.flower.lime": "labri'o ke xrula tarmi",
  "block.minecraft.banner.flower.magenta": "nukni xrula tarmi",
  "block.minecraft.banner.flower.orange": "narju xrula tarmi",
  "block.minecraft.banner.flower.pink": "xunblabi xrula tarmi",
  "block.minecraft.banner.flower.purple": "zirpu xrula tarmi",
  "block.minecraft.banner.flower.red": "xunre xrula tarmi",
  "block.minecraft.banner.flower.white": "blabi xrula tarmi",
  "block.minecraft.banner.flower.yellow": "pelxu xrula tarmi",
  "block.minecraft.banner.globe.black": "xekri bolci tarmi",
  "block.minecraft.banner.globe.blue": "blanu bolci tarmi",
  "block.minecraft.banner.globe.brown": "bunre bolci tarmi",
  "block.minecraft.banner.globe.cyan": "cicna bolci tarmi",
  "block.minecraft.banner.globe.gray": "grusi bolci tarmi",
  "block.minecraft.banner.globe.green": "crino bolci tarmi",
  "block.minecraft.banner.globe.light_blue": "labybla bolci tarmi",
  "block.minecraft.banner.globe.light_gray": "labgrusi bolci tarmi",
  "block.minecraft.banner.globe.lime": "labri'o ke bolci tarmi",
  "block.minecraft.banner.globe.magenta": "nukni bolci tarmi",
  "block.minecraft.banner.globe.orange": "narju bolci tarmi",
  "block.minecraft.banner.globe.pink": "xunblabi bolci tarmi",
  "block.minecraft.banner.globe.purple": "zirpu bolci tarmi",
  "block.minecraft.banner.globe.red": "xunre selboi",
  "block.minecraft.banner.globe.white": "blabi bolci tarmi",
  "block.minecraft.banner.globe.yellow": "pelxu bolci tarmi",
  "block.minecraft.banner.gradient.black": "le xekri ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.blue": "le blanu ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.brown": "le bunre ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.cyan": "le cicna ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.gray": "le grusi ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.green": "le crino ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.light_blue": "le labybla ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.light_gray": "le labrus ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.lime": "labri'o skacne",
  "block.minecraft.banner.gradient.magenta": "le nukni ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.orange": "le narju ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.pink": "le xunblabi ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.purple": "le zirpu ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.red": "le xunre ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.white": "le blabi ca zenba lo ka ruble",
  "block.minecraft.banner.gradient.yellow": "le pelxu ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.black": "le xekri ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.blue": "le blanu ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.brown": "le bunre ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.cyan": "le cicna ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.gray": "le grusi ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.green": "le crino ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.light_blue": "le labybla ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.light_gray": "le labrus ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.lime": "labri'o ke dizlo skacne",
  "block.minecraft.banner.gradient_up.magenta": "le nukni ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.orange": "le narju ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.pink": "le xunblabi ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.purple": "le zirpu ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.red": "le xunre ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.white": "le blabi ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.gradient_up.yellow": "le pelxu ne le dizlo ca zenba lo ka ruble",
  "block.minecraft.banner.guster.black": "xekri ke bifyda'u tarmi",
  "block.minecraft.banner.guster.blue": "blanu ke bifyda'u tarmi",
  "block.minecraft.banner.guster.brown": "bunre ke bifyda'u tarmi",
  "block.minecraft.banner.guster.cyan": "cicna ke bifyda'u tarmi",
  "block.minecraft.banner.guster.gray": "grusi ke bifyda'u tarmi",
  "block.minecraft.banner.guster.green": "crino ke bifyda'u tarmi",
  "block.minecraft.banner.guster.light_blue": "labybla ke bifyda'u tarmi",
  "block.minecraft.banner.guster.light_gray": "labgrusi ke bifyda'u tarmi",
  "block.minecraft.banner.guster.lime": "labri'o ke bifyda'u tarmi",
  "block.minecraft.banner.guster.magenta": "nukni ke bifyda'u tarmi",
  "block.minecraft.banner.guster.orange": "narju ke bifyda'u tarmi",
  "block.minecraft.banner.guster.pink": "penka ke bifyda'u tarmi",
  "block.minecraft.banner.guster.purple": "zirpu ke bifyda'u tarmi",
  "block.minecraft.banner.guster.red": "xunre ke bifyda'u tarmi",
  "block.minecraft.banner.guster.white": "blabi ke bifyda'u tarmi",
  "block.minecraft.banner.guster.yellow": "pelxu ke bifyda'u tarmi",
  "block.minecraft.banner.half_horizontal.black": "xekri xabmijpinsri",
  "block.minecraft.banner.half_horizontal.blue": "blanu xabmijpinsri",
  "block.minecraft.banner.half_horizontal.brown": "bunre xabmijpinsri",
  "block.minecraft.banner.half_horizontal.cyan": "cicna xabmijpinsri",
  "block.minecraft.banner.half_horizontal.gray": "grusi xabmijpinsri",
  "block.minecraft.banner.half_horizontal.green": "crino xabmijpinsri",
  "block.minecraft.banner.half_horizontal.light_blue": "labybla xabmijpinsri",
  "block.minecraft.banner.half_horizontal.light_gray": "labgrusi xabmijpinsri",
  "block.minecraft.banner.half_horizontal.lime": "labri'o xabmijpinsri",
  "block.minecraft.banner.half_horizontal.magenta": "nukni xabmijpinsri",
  "block.minecraft.banner.half_horizontal.orange": "narju xabmijpinsri",
  "block.minecraft.banner.half_horizontal.pink": "penka xabmijpinsri",
  "block.minecraft.banner.half_horizontal.purple": "zirpu xabmijpinsri",
  "block.minecraft.banner.half_horizontal.red": "xunre xabmijpinsri",
  "block.minecraft.banner.half_horizontal.white": "blabi xabmijpinsri",
  "block.minecraft.banner.half_horizontal.yellow": "pelxu xabmijpinsri",
  "block.minecraft.banner.half_horizontal_bottom.black": "xekri dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.blue": "blanu dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.brown": "bunre dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "cicna dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.gray": "grusi dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.green": "crino dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "labybla dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "labgrusi dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.lime": "labri'o ke dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "nukni dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.orange": "narju dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.pink": "penka dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.purple": "zirpu dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.red": "xunre dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.white": "blabi dziraipau xadba kurfa",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "pelxu dziraipau xadba kurfa",
  "block.minecraft.banner.half_vertical.black": "xekri pritu xabkurfa",
  "block.minecraft.banner.half_vertical.blue": "blanu pritu xabkurfa",
  "block.minecraft.banner.half_vertical.brown": "bunre pritu xabkurfa",
  "block.minecraft.banner.half_vertical.cyan": "cicna pritu xabkurfa",
  "block.minecraft.banner.half_vertical.gray": "grusi pritu xabkurfa",
  "block.minecraft.banner.half_vertical.green": "crino pritu xabkurfa",
  "block.minecraft.banner.half_vertical.light_blue": "labybla pritu xabkurfa",
  "block.minecraft.banner.half_vertical.light_gray": "labgrusi pritu xabkurfa",
  "block.minecraft.banner.half_vertical.lime": "labri'o ke pritu xabkurfa",
  "block.minecraft.banner.half_vertical.magenta": "nukni pritu xabkurfa",
  "block.minecraft.banner.half_vertical.orange": "narju pritu xabkurfa",
  "block.minecraft.banner.half_vertical.pink": "penka pritu xabkurfa",
  "block.minecraft.banner.half_vertical.purple": "zirpu pritu xabkurfa",
  "block.minecraft.banner.half_vertical.red": "xunre pritu xabkurfa",
  "block.minecraft.banner.half_vertical.white": "blabi pritu xabkurfa",
  "block.minecraft.banner.half_vertical.yellow": "pelxu pritu xabkurfa",
  "block.minecraft.banner.half_vertical_right.black": "xekri zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.blue": "blanu zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.brown": "bunre zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.cyan": "cicna zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.gray": "grusi zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.green": "crino zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.light_blue": "labybla zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.light_gray": "labgrusi zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.lime": "labri'o ke zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.magenta": "nukni zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.orange": "narju zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.pink": "penka zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.purple": "zirpu zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.red": "xunre zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.white": "blabi zunle xadba cibjgatai",
  "block.minecraft.banner.half_vertical_right.yellow": "pelxu zunle xadba cibjgatai",
  "block.minecraft.banner.mojang.black": "xekri sumdai",
  "block.minecraft.banner.mojang.blue": "blanu sumdai",
  "block.minecraft.banner.mojang.brown": "bunre sumdai",
  "block.minecraft.banner.mojang.cyan": "cicna sumdai",
  "block.minecraft.banner.mojang.gray": "grusi sumdai",
  "block.minecraft.banner.mojang.green": "crino sumdai",
  "block.minecraft.banner.mojang.light_blue": "labybla sumdai",
  "block.minecraft.banner.mojang.light_gray": "labgrusi sumdai",
  "block.minecraft.banner.mojang.lime": "labri'o sumdai",
  "block.minecraft.banner.mojang.magenta": "nukni sumdai",
  "block.minecraft.banner.mojang.orange": "narju sumdai",
  "block.minecraft.banner.mojang.pink": "penka sumdai",
  "block.minecraft.banner.mojang.purple": "zirpu sumdai",
  "block.minecraft.banner.mojang.red": "xunre sumdai",
  "block.minecraft.banner.mojang.white": "blabi sumdai",
  "block.minecraft.banner.mojang.yellow": "pelxu sumdai",
  "block.minecraft.banner.piglin.black": ".i xekri xajyzbitai",
  "block.minecraft.banner.piglin.blue": ".i blanu xajyzbitai",
  "block.minecraft.banner.piglin.brown": ".i bunre xajyzbitai",
  "block.minecraft.banner.piglin.cyan": ".i cicna xajyzbitai",
  "block.minecraft.banner.piglin.gray": ".i grusi xajyzbitai",
  "block.minecraft.banner.piglin.green": ".i crino xajyzbitai",
  "block.minecraft.banner.piglin.light_blue": ".i labybla xajyzbitai",
  "block.minecraft.banner.piglin.light_gray": ".i labgrusi xajyzbitai",
  "block.minecraft.banner.piglin.lime": "labri'o xajyzbitai",
  "block.minecraft.banner.piglin.magenta": ".i nukni xajyzbitai",
  "block.minecraft.banner.piglin.orange": ".i narju xajyzbitai",
  "block.minecraft.banner.piglin.pink": ".i penku xajyzbitai",
  "block.minecraft.banner.piglin.purple": ".i zirpu xajyzbitai",
  "block.minecraft.banner.piglin.red": "xunre xajyzbi",
  "block.minecraft.banner.piglin.white": ".i blabi xajyzbitai",
  "block.minecraft.banner.piglin.yellow": ".i pelxu xajyzbitai",
  "block.minecraft.banner.rhombus.black": "xekri sa'orkurfa",
  "block.minecraft.banner.rhombus.blue": "blanu sa'orkurfa",
  "block.minecraft.banner.rhombus.brown": "bunre sa'orkurfa",
  "block.minecraft.banner.rhombus.cyan": "cicna sa'orkurfa",
  "block.minecraft.banner.rhombus.gray": "grusi sa'orkurfa",
  "block.minecraft.banner.rhombus.green": "crino sa'orkurfa",
  "block.minecraft.banner.rhombus.light_blue": "labybla sa'orkurfa",
  "block.minecraft.banner.rhombus.light_gray": "labgrusi sa'orkurfa",
  "block.minecraft.banner.rhombus.lime": "labri'o sa'orkurfa",
  "block.minecraft.banner.rhombus.magenta": "nukni sa'orkurfa",
  "block.minecraft.banner.rhombus.orange": "narju sa'orkurfa",
  "block.minecraft.banner.rhombus.pink": "penka sa'orkurfa",
  "block.minecraft.banner.rhombus.purple": "zirpu sa'orkurfa",
  "block.minecraft.banner.rhombus.red": "xunre sa'orkurfa",
  "block.minecraft.banner.rhombus.white": "blabi sa'orkurfa",
  "block.minecraft.banner.rhombus.yellow": "pelxu sa'orkurfa",
  "block.minecraft.banner.skull.black": "xekri sedbo'u tarmi",
  "block.minecraft.banner.skull.blue": "blanu sedbo'u tarmi",
  "block.minecraft.banner.skull.brown": "bunre sedbo'u tarmi",
  "block.minecraft.banner.skull.cyan": "cicna sedbo'u tarmi",
  "block.minecraft.banner.skull.gray": "grusi sedbo'u tarmi",
  "block.minecraft.banner.skull.green": "crino sedbo'u tarmi",
  "block.minecraft.banner.skull.light_blue": "labybla sedbo'u tarmi",
  "block.minecraft.banner.skull.light_gray": "labyrus sedbo'u tarmi",
  "block.minecraft.banner.skull.lime": "labri'o ke sedbo'u tarmi",
  "block.minecraft.banner.skull.magenta": "nukni sedbo'u tarmi",
  "block.minecraft.banner.skull.orange": "narju sedbo'u tarmi",
  "block.minecraft.banner.skull.pink": "xunblabi sedbo'u tarmi",
  "block.minecraft.banner.skull.purple": "zirpu sedbo'u tarmi",
  "block.minecraft.banner.skull.red": "xunre sedbo'u tarmi",
  "block.minecraft.banner.skull.white": "blabi sedbo'u tarmi",
  "block.minecraft.banner.skull.yellow": "pelxu sedbo'u tarmi",
  "block.minecraft.banner.small_stripes.black": "xekri rajytegysri",
  "block.minecraft.banner.small_stripes.blue": "blanu rajytegysri",
  "block.minecraft.banner.small_stripes.brown": "bunre rajytegysri",
  "block.minecraft.banner.small_stripes.cyan": "cicna rajytegysri",
  "block.minecraft.banner.small_stripes.gray": "grusi rajytegysri",
  "block.minecraft.banner.small_stripes.green": "crino rajytegysri",
  "block.minecraft.banner.small_stripes.light_blue": "labybla rajytegysri",
  "block.minecraft.banner.small_stripes.light_gray": "labgrusi rajytegysri",
  "block.minecraft.banner.small_stripes.lime": "labri'o rajytegysri",
  "block.minecraft.banner.small_stripes.magenta": "nukni rajytegysri",
  "block.minecraft.banner.small_stripes.orange": "narju rajytegysri",
  "block.minecraft.banner.small_stripes.pink": "penka rajytegysri",
  "block.minecraft.banner.small_stripes.purple": "zirpu rajytegysri",
  "block.minecraft.banner.small_stripes.red": "xunre rajytegysri",
  "block.minecraft.banner.small_stripes.white": "blabi rajytegysri",
  "block.minecraft.banner.small_stripes.yellow": "pelxu rajytegysri",
  "block.minecraft.banner.square_bottom_left.black": "xekri dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.blue": "blanu dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.brown": "bunre dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.cyan": "cicna dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.gray": "grusi dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.green": "crino dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.light_blue": "labybla dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.light_gray": "labgrusi dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.lime": "labri'o ke dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.magenta": "nukni dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.orange": "narju dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.pink": "penka dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.purple": "zirpu dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.red": "xunre dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.white": "blabi dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_left.yellow": "pelxu dziraipau pritu kurfa",
  "block.minecraft.banner.square_bottom_right.black": "xekri dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.blue": "blanu dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.brown": "grusi dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.cyan": "cicna dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.gray": "grusi dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.green": "crino dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.light_blue": "labybla dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.light_gray": "labgrusi dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.lime": "labri'o ke dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.magenta": "nukni dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.orange": "narju dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.pink": "penka dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.purple": "zirpu dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.red": "xunre dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.white": "blabi dziraipau zulkurfa",
  "block.minecraft.banner.square_bottom_right.yellow": "pelxu dziraipau zulkurfa",
  "block.minecraft.banner.square_top_left.black": "xekri galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.blue": "blanu galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.brown": "bunre galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.cyan": "cicna galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.gray": "grusi galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.green": "crino dziraipau zulkurfa",
  "block.minecraft.banner.square_top_left.light_blue": "labybla galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.light_gray": "labgrusi galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.lime": "labri'o ke galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.magenta": "nukni galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.orange": "narju galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.pink": "penka galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.purple": "zirpu galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.red": "xunre dziraipau zulkurfa",
  "block.minecraft.banner.square_top_left.white": "blabi galraipau pritu kurfa",
  "block.minecraft.banner.square_top_left.yellow": "pelxu galraipau pritu kurfa",
  "block.minecraft.banner.square_top_right.black": "xekri galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.blue": "blanu galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.brown": "bunre galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.cyan": "cicna galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.gray": "grusi galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.green": "crino galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.light_blue": "labybla galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.light_gray": "labgrusi galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.lime": "labri'o ke galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.magenta": "nukni galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.orange": "narju galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.pink": "penka galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.purple": "zirpu galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.red": "xunre galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.white": "blabi galraipau zulkurfa",
  "block.minecraft.banner.square_top_right.yellow": "pelxu galraipau zulkurfa",
  "block.minecraft.banner.straight_cross.black": "xekri kuctai",
  "block.minecraft.banner.straight_cross.blue": "blanu kuctai",
  "block.minecraft.banner.straight_cross.brown": "bunre kuctai",
  "block.minecraft.banner.straight_cross.cyan": "cicna kuctai",
  "block.minecraft.banner.straight_cross.gray": "grusi kuctai",
  "block.minecraft.banner.straight_cross.green": "crino kuctai",
  "block.minecraft.banner.straight_cross.light_blue": "labybla kuctai",
  "block.minecraft.banner.straight_cross.light_gray": "labgrusi kuctai",
  "block.minecraft.banner.straight_cross.lime": "labri'o kuctai",
  "block.minecraft.banner.straight_cross.magenta": "nukni kuctai",
  "block.minecraft.banner.straight_cross.orange": "narju kuctai",
  "block.minecraft.banner.straight_cross.pink": "penka kuctai",
  "block.minecraft.banner.straight_cross.purple": "zirpu kuctai",
  "block.minecraft.banner.straight_cross.red": "xunre kuctai",
  "block.minecraft.banner.straight_cross.white": "blabi kuctai",
  "block.minecraft.banner.straight_cross.yellow": "pelxu kuctai",
  "block.minecraft.banner.stripe_bottom.black": "xekri dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.blue": "blanu dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.brown": "bunre dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.cyan": "cicna dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.gray": "grusi dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.green": "crino dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.light_blue": "labybla dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.light_gray": "labgrusi dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.lime": "labri'o ke dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.magenta": "nukni dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.orange": "narju dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.pink": "penka dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.purple": "zirpu dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.red": "xunre dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.white": "blabi dziraipau pinsri",
  "block.minecraft.banner.stripe_bottom.yellow": "pelxu dziraipau pinsri",
  "block.minecraft.banner.stripe_center.black": "xekri rajysri",
  "block.minecraft.banner.stripe_center.blue": "blanu rajysri",
  "block.minecraft.banner.stripe_center.brown": "bunre rajysri",
  "block.minecraft.banner.stripe_center.cyan": "cicna rajysri",
  "block.minecraft.banner.stripe_center.gray": "grusi rajysri",
  "block.minecraft.banner.stripe_center.green": "crino rajysri",
  "block.minecraft.banner.stripe_center.light_blue": "labybla rajysri",
  "block.minecraft.banner.stripe_center.light_gray": "labgrusi rajysri",
  "block.minecraft.banner.stripe_center.lime": "labri'o rajysri",
  "block.minecraft.banner.stripe_center.magenta": "nukni rajysri",
  "block.minecraft.banner.stripe_center.orange": "narju rajysri",
  "block.minecraft.banner.stripe_center.pink": "penka rajysri",
  "block.minecraft.banner.stripe_center.purple": "zirpu rajysri",
  "block.minecraft.banner.stripe_center.red": "xunre rajysri",
  "block.minecraft.banner.stripe_center.white": "blabi rajysri",
  "block.minecraft.banner.stripe_center.yellow": "pelxu rajysri",
  "block.minecraft.banner.stripe_downleft.black": "xekri zulsa'osri",
  "block.minecraft.banner.stripe_downleft.blue": "blanu zulsa'osri",
  "block.minecraft.banner.stripe_downleft.brown": "bunre zulsa'osri",
  "block.minecraft.banner.stripe_downleft.cyan": "cicna zulsa'osri",
  "block.minecraft.banner.stripe_downleft.gray": "grusi zulsa'osri",
  "block.minecraft.banner.stripe_downleft.green": "crino zulsa'osri",
  "block.minecraft.banner.stripe_downleft.light_blue": "labybla zulsa'osri",
  "block.minecraft.banner.stripe_downleft.light_gray": "labgrusi zulsa'osri",
  "block.minecraft.banner.stripe_downleft.lime": "labri'o zulsa'osri",
  "block.minecraft.banner.stripe_downleft.magenta": "nukni zulsa'osri",
  "block.minecraft.banner.stripe_downleft.orange": "narju zulsa'osri",
  "block.minecraft.banner.stripe_downleft.pink": "penka zulsa'osri",
  "block.minecraft.banner.stripe_downleft.purple": "zirpu zulsa'osri",
  "block.minecraft.banner.stripe_downleft.red": "xunre zulsa'osri",
  "block.minecraft.banner.stripe_downleft.white": "blabi zulsa'osri",
  "block.minecraft.banner.stripe_downleft.yellow": "pelxu zulsa'osri",
  "block.minecraft.banner.stripe_downright.black": "xekri sa'osri",
  "block.minecraft.banner.stripe_downright.blue": "blanu sa'osri",
  "block.minecraft.banner.stripe_downright.brown": "bunre sa'osri",
  "block.minecraft.banner.stripe_downright.cyan": "cicna sa'osri",
  "block.minecraft.banner.stripe_downright.gray": "grusi sa'osri",
  "block.minecraft.banner.stripe_downright.green": "crino sa'osri",
  "block.minecraft.banner.stripe_downright.light_blue": "labybla sa'osri",
  "block.minecraft.banner.stripe_downright.light_gray": "labgrusi sa'osri",
  "block.minecraft.banner.stripe_downright.lime": "labri'o sa'osri",
  "block.minecraft.banner.stripe_downright.magenta": "nukni sa'osri",
  "block.minecraft.banner.stripe_downright.orange": "narju sa'osri",
  "block.minecraft.banner.stripe_downright.pink": "penka sa'osri",
  "block.minecraft.banner.stripe_downright.purple": "zirpu sa'osri",
  "block.minecraft.banner.stripe_downright.red": "xunre sa'osri",
  "block.minecraft.banner.stripe_downright.white": "blabi sa'osri",
  "block.minecraft.banner.stripe_downright.yellow": "pelxu sa'osri",
  "block.minecraft.banner.stripe_left.black": "xekri pritu rajysri",
  "block.minecraft.banner.stripe_left.blue": "blanu pritu rajysri",
  "block.minecraft.banner.stripe_left.brown": "bunre pritu rajysri",
  "block.minecraft.banner.stripe_left.cyan": "cicna pritu rajysri",
  "block.minecraft.banner.stripe_left.gray": "grusi pritu rajysri",
  "block.minecraft.banner.stripe_left.green": "crino pritu rajysri",
  "block.minecraft.banner.stripe_left.light_blue": "labybla pritu rajysri",
  "block.minecraft.banner.stripe_left.light_gray": "labgrusi pritu rajysri",
  "block.minecraft.banner.stripe_left.lime": "labri'o ke pritu rajysri",
  "block.minecraft.banner.stripe_left.magenta": "nukni pritu rajysri",
  "block.minecraft.banner.stripe_left.orange": "narju pritu rajysri",
  "block.minecraft.banner.stripe_left.pink": "penka pritu rajysri",
  "block.minecraft.banner.stripe_left.purple": "zirpu pritu rajysri",
  "block.minecraft.banner.stripe_left.red": "xunre pritu rajysri",
  "block.minecraft.banner.stripe_left.white": "blabi pritu rajysri",
  "block.minecraft.banner.stripe_left.yellow": "pelxu pritu rajysri",
  "block.minecraft.banner.stripe_middle.black": "xekri mijpinsri",
  "block.minecraft.banner.stripe_middle.blue": "blanu mijpinsri",
  "block.minecraft.banner.stripe_middle.brown": "grusi mijpinsri",
  "block.minecraft.banner.stripe_middle.cyan": "cicna mijpinsri",
  "block.minecraft.banner.stripe_middle.gray": "grusi mijpinsri",
  "block.minecraft.banner.stripe_middle.green": "crino mijpinsri",
  "block.minecraft.banner.stripe_middle.light_blue": "labybla mijpinsri",
  "block.minecraft.banner.stripe_middle.light_gray": "labgrusi mijpinsri",
  "block.minecraft.banner.stripe_middle.lime": "labri'o mijpinsri",
  "block.minecraft.banner.stripe_middle.magenta": "nukni mijpinsri",
  "block.minecraft.banner.stripe_middle.orange": "narju mijpinsri",
  "block.minecraft.banner.stripe_middle.pink": "penka mijpinsri",
  "block.minecraft.banner.stripe_middle.purple": "zirpu mijpinsri",
  "block.minecraft.banner.stripe_middle.red": "xunre mijpinsri",
  "block.minecraft.banner.stripe_middle.white": "blabi mijpinsri",
  "block.minecraft.banner.stripe_middle.yellow": "pelxu mijpinsri",
  "block.minecraft.banner.stripe_right.black": "xekri zulrajysri",
  "block.minecraft.banner.stripe_right.blue": "blanu zulrajysri",
  "block.minecraft.banner.stripe_right.brown": "bunre zulrajysri",
  "block.minecraft.banner.stripe_right.cyan": "cicna zulrajysri",
  "block.minecraft.banner.stripe_right.gray": "grusi zulrajysri",
  "block.minecraft.banner.stripe_right.green": "crino zulrajysri",
  "block.minecraft.banner.stripe_right.light_blue": "labybla zulrajysri",
  "block.minecraft.banner.stripe_right.light_gray": "labgrusi zulrajysri",
  "block.minecraft.banner.stripe_right.lime": "pelri'o zulrajysri",
  "block.minecraft.banner.stripe_right.magenta": "nukni zulrajysri",
  "block.minecraft.banner.stripe_right.orange": "narju zulrajysri",
  "block.minecraft.banner.stripe_right.pink": "penka zulrajysri",
  "block.minecraft.banner.stripe_right.purple": "zirpu zulrajysri",
  "block.minecraft.banner.stripe_right.red": "xunre zulrajysri",
  "block.minecraft.banner.stripe_right.white": "blabi zulrajysri",
  "block.minecraft.banner.stripe_right.yellow": "pelxu zulrajysri",
  "block.minecraft.banner.stripe_top.black": "xekri galraipau pinsri",
  "block.minecraft.banner.stripe_top.blue": "blanu galraipau pinsri",
  "block.minecraft.banner.stripe_top.brown": "bunre galraipau pinsri",
  "block.minecraft.banner.stripe_top.cyan": "cicna galraipau pinsri",
  "block.minecraft.banner.stripe_top.gray": "grusi galraipau pinsri",
  "block.minecraft.banner.stripe_top.green": "crino galraipau pinsri",
  "block.minecraft.banner.stripe_top.light_blue": "labybla galraipau pinsri",
  "block.minecraft.banner.stripe_top.light_gray": "labgrusi galraipau pinsri",
  "block.minecraft.banner.stripe_top.lime": "labri'o ke galraipau pinsri",
  "block.minecraft.banner.stripe_top.magenta": "nukni galraipau pinsri",
  "block.minecraft.banner.stripe_top.orange": "narju galraipau pinsri",
  "block.minecraft.banner.stripe_top.pink": "penka galraipau pinsri",
  "block.minecraft.banner.stripe_top.purple": "zirpu galraipau pinsri",
  "block.minecraft.banner.stripe_top.red": "xunre galraipau pinsri",
  "block.minecraft.banner.stripe_top.white": "blabi galraipau pinsri",
  "block.minecraft.banner.stripe_top.yellow": "pelxu galraipau pinsri",
  "block.minecraft.banner.triangle_bottom.black": "xekri dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.blue": "blanu dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.brown": "bunre dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.cyan": "cicna dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.gray": "grusi dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.green": "crino dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.light_blue": "labybla dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.light_gray": "labgrusi dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.lime": "labri'o ke dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.magenta": "nukni dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.orange": "narju dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.pink": "penka dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.purple": "zirpu dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.red": "xunre dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.white": "blabi dziraipau cibjgatai",
  "block.minecraft.banner.triangle_bottom.yellow": "pelxu dziraipau cibjgatai",
  "block.minecraft.banner.triangle_top.black": "xekri galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.blue": "blanu galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.brown": "bunre galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.cyan": "cicna galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.gray": "grusi galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.green": "crino galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.light_blue": "labybla galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.light_gray": "labgrusi galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.lime": "labri'o ke galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.magenta": "nukni galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.orange": "narju galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.pink": "penka galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.purple": "zirpu galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.red": "xunre galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.white": "blabi galraipau cibjgatai",
  "block.minecraft.banner.triangle_top.yellow": "pelxu galraipau cibjgatai",
  "block.minecraft.banner.triangles_bottom.black": "xekri dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.blue": "blanu dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.brown": "bunre dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.cyan": "cicna dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.gray": "grusi dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.green": "crino dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.light_blue": "labybla dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.light_gray": "labgrusi dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.lime": "labri'o ke dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.magenta": "nukni dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.orange": "narju dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.pink": "penka dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.purple": "zirpu dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.red": "xunre dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.white": "blabi dziraipau sra'akpa",
  "block.minecraft.banner.triangles_bottom.yellow": "pelxu dziraipau sra'akpa",
  "block.minecraft.banner.triangles_top.black": "xekri galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.blue": "blanu galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.brown": "bunre galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.cyan": "cicna galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.gray": "grusi galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.green": "crino galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.light_blue": "labybla galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.light_gray": "labgrusi galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.lime": "labri'o ke galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.magenta": "nukni galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.orange": "narju galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.pink": "penka galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.purple": "zirpu galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.red": "xunre galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.white": "blabi galraipau sra'akpa",
  "block.minecraft.banner.triangles_top.yellow": "pelxu galraipau sra'akpa",
  "block.minecraft.barrel": "slanyvau",
  "block.minecraft.barrier": "zunbi'u",
  "block.minecraft.basalt": "kamjyro'i",
  "block.minecraft.beacon": "barda tergu'i",
  "block.minecraft.beacon.primary": "pamai vlipa",
  "block.minecraft.beacon.secondary": "remoi vlipa",
  "block.minecraft.bed.no_sleep": ".i do ka'e sipna ca po'o lo nicte ja lo lidvilti'a",
  "block.minecraft.bed.not_safe": ".i na cumki fa lo nu sipna .i lo cizda'u cu jibni",
  "block.minecraft.bed.obstructed": ".i le vi ckana na se joska'e do",
  "block.minecraft.bed.occupied": ".i le vi ckana ca canlu",
  "block.minecraft.bed.too_far_away": ".i do na ka'e sipna ki'u lonu lo ckana cu darno",
  "block.minecraft.bedrock": "cevrokci",
  "block.minecraft.bee_nest": "bifce zdani",
  "block.minecraft.beehive": "rutni bicyzda",
  "block.minecraft.beetroots": "spatrtensai",
  "block.minecraft.bell": "janbe",
  "block.minecraft.big_dripleaf": "barda sinpezli",
  "block.minecraft.big_dripleaf_stem": "barda sinpezli stani",
  "block.minecraft.birch_button": ".eptula batke",
  "block.minecraft.birch_door": ".eptula vrogai",
  "block.minecraft.birch_fence": ".eptula garbi'u",
  "block.minecraft.birch_fence_gate": ".eptula garbimvrogai",
  "block.minecraft.birch_hanging_sign": ".eptula ke dandu lertapla",
  "block.minecraft.birch_leaves": ".eptula pezli",
  "block.minecraft.birch_log": ".eptula stani",
  "block.minecraft.birch_planks": ".eptula tanbo",
  "block.minecraft.birch_pressure_plate": ".eptula danrytapla",
  "block.minecraft.birch_sapling": ".eptula ciftricu",
  "block.minecraft.birch_shelf": ".eptula kajna",
  "block.minecraft.birch_sign": ".eptula lertapla",
  "block.minecraft.birch_slab": ".eptula xabybli",
  "block.minecraft.birch_stairs": ".eptula serti",
  "block.minecraft.birch_trapdoor": ".eptula lolvrogai",
  "block.minecraft.birch_wall_hanging_sign": "bitmu ke .eptula ke dandu lertapla",
  "block.minecraft.birch_wall_sign": ".eptula ke bitmu lertapla",
  "block.minecraft.birch_wood": ".eptula mudri",
  "block.minecraft.black_banner": "xekri srilanci",
  "block.minecraft.black_bed": "xekri ckana",
  "block.minecraft.black_candle": "xekri laktergu'i",
  "block.minecraft.black_candle_cake": "xekri laktergu'i kenka",
  "block.minecraft.black_carpet": "xekri buklolgai",
  "block.minecraft.black_concrete": "xekri xumrkonkreto",
  "block.minecraft.black_concrete_powder": "xekri xumrkonkreto purmo",
  "block.minecraft.black_glazed_terracotta": "le xekri stakrterakota poi jelca",
  "block.minecraft.black_shulker_box": "xekri ke me la .cylkr. tanxe",
  "block.minecraft.black_stained_glass": "xekri skari blaci",
  "block.minecraft.black_stained_glass_pane": "xekri skari canko blaci",
  "block.minecraft.black_terracotta": "xekri stakrterakota",
  "block.minecraft.black_wool": "xekri sunla",
  "block.minecraft.blackstone": "xekro'i",
  "block.minecraft.blackstone_slab": "xekro'i xabybli",
  "block.minecraft.blackstone_stairs": "xekro'i serti",
  "block.minecraft.blackstone_wall": "xekro'i bitmu",
  "block.minecraft.blast_furnace": "baltoknu",
  "block.minecraft.blue_banner": "blanu srilancu",
  "block.minecraft.blue_bed": "blanu ckana",
  "block.minecraft.blue_candle": "blanu laktergu'i",
  "block.minecraft.blue_candle_cake": "blanu laktergu'i kenka",
  "block.minecraft.blue_carpet": "blanu buklolgai",
  "block.minecraft.blue_concrete": "blanu xumrkonkreto",
  "block.minecraft.blue_concrete_powder": "blanu xumrkonkreto purmo",
  "block.minecraft.blue_glazed_terracotta": "le blabi stakrterakota poi se fagri",
  "block.minecraft.blue_ice": "blanu bisli",
  "block.minecraft.blue_orchid": "blalarki",
  "block.minecraft.blue_shulker_box": "blanu ke me la .cylkr. tanxe",
  "block.minecraft.blue_stained_glass": "blanu skari blaci",
  "block.minecraft.blue_stained_glass_pane": "blanu skari canko blaci",
  "block.minecraft.blue_terracotta": "blanu stakrterakota",
  "block.minecraft.blue_wool": "blanu sunla",
  "block.minecraft.bone_block": "bongu bliku",
  "block.minecraft.bookshelf": "cukta kajna",
  "block.minecraft.brain_coral": "bentai ricnritrina",
  "block.minecraft.brain_coral_block": "bentai ricnritrina bliku",
  "block.minecraft.brain_coral_fan": "bentai ricnritrina tolfalnu",
  "block.minecraft.brain_coral_wall_fan": "bentai ricnritrina bimtolfalnu",
  "block.minecraft.brewing_stand": "selpinxe jukpa jubme",
  "block.minecraft.brick_slab": "kitybli xabybli",
  "block.minecraft.brick_stairs": "kitybli serti",
  "block.minecraft.brick_wall": "kitybli bitmu",
  "block.minecraft.bricks": "kitybli",
  "block.minecraft.brown_banner": "bunre srilanci",
  "block.minecraft.brown_bed": "bunre ckana",
  "block.minecraft.brown_candle": "bunre laktergu'i",
  "block.minecraft.brown_candle_cake": "bunre laktergu'i kenka",
  "block.minecraft.brown_carpet": "bunre buklolgai",
  "block.minecraft.brown_concrete": "bunre xumrkonkreto",
  "block.minecraft.brown_concrete_powder": "bunre xumrkonkreto purmo",
  "block.minecraft.brown_glazed_terracotta": "le bunre stakrterakota poi jelca",
  "block.minecraft.brown_mushroom": "bunre gumri",
  "block.minecraft.brown_mushroom_block": "bunre gumri bliku",
  "block.minecraft.brown_shulker_box": "bunre ke me la .cylkr. tanxe",
  "block.minecraft.brown_stained_glass": "bunre skari blaci",
  "block.minecraft.brown_stained_glass_pane": "bunre skari canko blaci",
  "block.minecraft.brown_terracotta": "bunre stakrterakota",
  "block.minecraft.brown_wool": "bunre sunla",
  "block.minecraft.bubble_column": "varboi kamju",
  "block.minecraft.bubble_coral": "fomtai ricnritrina",
  "block.minecraft.bubble_coral_block": "fomtai ricnritrina bliku",
  "block.minecraft.bubble_coral_fan": "fomtai ricnritrina tolfalnu",
  "block.minecraft.bubble_coral_wall_fan": "fomtai ricnritrina bimtolfalnu",
  "block.minecraft.budding_amethyst": ".amtisti ba'orgau",
  "block.minecraft.bush": "dzitricu",
  "block.minecraft.cactus": "jesyspa",
  "block.minecraft.cactus_flower": "jesyspa xrula",
  "block.minecraft.cake": "titnanba",
  "block.minecraft.calcite": "bogytabno",
  "block.minecraft.calibrated_sculk_sensor": "se xelmredragau ke me la .skylk. ganse",
  "block.minecraft.campfire": "gikyfagri",
  "block.minecraft.candle": "laktergu'i",
  "block.minecraft.candle_cake": "laktergu'i kenka",
  "block.minecraft.carrots": "najgenja",
  "block.minecraft.cartography_table": "catplajbu",
  "block.minecraft.carved_pumpkin": "selsraku guzmrkukurbita",
  "block.minecraft.cauldron": "patxu",
  "block.minecraft.cave_air": "kevna vacri",
  "block.minecraft.cave_vines": "kevna skospa",
  "block.minecraft.cave_vines_plant": "kevna skospa spati",
  "block.minecraft.chain": "linsi",
  "block.minecraft.chain_command_block": ".iinsi ziltinbe bliku",
  "block.minecraft.cherry_button": "ricrceraso batke",
  "block.minecraft.cherry_door": "ricrceraso vrogai",
  "block.minecraft.cherry_fence": "ricrceraso garbi'u",
  "block.minecraft.cherry_fence_gate": "ricrceraso garbimvrogai",
  "block.minecraft.cherry_hanging_sign": "ricrceraso ke dandu lertapla",
  "block.minecraft.cherry_leaves": "ricrceraso pezli",
  "block.minecraft.cherry_log": "ricrceraso stani",
  "block.minecraft.cherry_planks": "ricrceraso tanbo",
  "block.minecraft.cherry_pressure_plate": "ricrceraso danrytapla",
  "block.minecraft.cherry_sapling": "ricrceraso ciftricu",
  "block.minecraft.cherry_shelf": "ricrceraso kajna",
  "block.minecraft.cherry_sign": "ricrceraso lertapla",
  "block.minecraft.cherry_slab": "ricrceraso xabybli",
  "block.minecraft.cherry_stairs": "ricrceraso serti",
  "block.minecraft.cherry_trapdoor": "ricrceraso lolvrogai",
  "block.minecraft.cherry_wall_hanging_sign": "bitmu ke ricrceraso ke dandu lertapla",
  "block.minecraft.cherry_wall_sign": "ricrceraso ke bitmu lertapla",
  "block.minecraft.cherry_wood": "ricrceraso mudri",
  "block.minecraft.chest": "vasru",
  "block.minecraft.chipped_anvil": "selxai toltce jimda'izbe",
  "block.minecraft.chiseled_bookshelf": "selja'i ckukajna",
  "block.minecraft.chiseled_copper": "selja'i ke tunka bliku",
  "block.minecraft.chiseled_deepslate": "selja'i cnoro'i",
  "block.minecraft.chiseled_nether_bricks": "selja'i ke dzimu'e kubli bliku",
  "block.minecraft.chiseled_polished_blackstone": "selja'i ke selspali xekro'i",
  "block.minecraft.chiseled_quartz_block": "selja'i ke krilrkartso bliku",
  "block.minecraft.chiseled_red_sandstone": "selja'i ke xunre canro'i",
  "block.minecraft.chiseled_resin_bricks": "selja'i ke gomja bliku",
  "block.minecraft.chiseled_sandstone": "selja'i canro'i",
  "block.minecraft.chiseled_stone_bricks": "selja'i rokci bliku",
  "block.minecraft.chiseled_tuff": "selja'i fagma'apucro'i",
  "block.minecraft.chiseled_tuff_bricks": "selja'i ke fagma'apucro'i bliku",
  "block.minecraft.chorus_flower": "girza'a xrula",
  "block.minecraft.chorus_plant": "girza'a spati",
  "block.minecraft.clay": "kliti",
  "block.minecraft.closed_eyeblossom": "ganlo kalxrula",
  "block.minecraft.coal_block": "kolme bliku",
  "block.minecraft.coal_ore": "kolme kunra",
  "block.minecraft.coarse_dirt": "rufsu dertu",
  "block.minecraft.cobbled_deepslate": "spofu cnoro'i",
  "block.minecraft.cobbled_deepslate_slab": "spofu cnoro'i xabybli",
  "block.minecraft.cobbled_deepslate_stairs": "spofu cnoro'i serti",
  "block.minecraft.cobbled_deepslate_wall": "spofu cnoro'i bitmu",
  "block.minecraft.cobblestone": "spiro'i",
  "block.minecraft.cobblestone_slab": "spiro'i xabybli",
  "block.minecraft.cobblestone_stairs": "spiro'i serti",
  "block.minecraft.cobblestone_wall": "spiro'i bitmu",
  "block.minecraft.cobweb": "jukyzda",
  "block.minecraft.cocoa": "cakla",
  "block.minecraft.command_block": "ziltinbe bliku",
  "block.minecraft.comparator": "me la redston. karbi",
  "block.minecraft.composter": "rikfre pulce ke fusra minji",
  "block.minecraft.conduit": "xasycei kroxo",
  "block.minecraft.copper_bars": "tunka garna",
  "block.minecraft.copper_block": "tunka bliku",
  "block.minecraft.copper_bulb": "tunka tergu'i",
  "block.minecraft.copper_chain": "tunka linsi",
  "block.minecraft.copper_chest": "tunka vasru",
  "block.minecraft.copper_door": "tunka vrogai",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "tunka ga'avro",
  "block.minecraft.copper_lantern": "tunka dadytergu'i",
  "block.minecraft.copper_ore": "tunka kunra",
  "block.minecraft.copper_torch": "tunka fagytergu'i",
  "block.minecraft.copper_trapdoor": "tunka lolvrogai",
  "block.minecraft.copper_wall_torch": "bi'uzva ke tunka fagytergu'i",
  "block.minecraft.cornflower": "centaureia",
  "block.minecraft.cracked_deepslate_bricks": "fenra cnoro'i kitybli",
  "block.minecraft.cracked_deepslate_tiles": "fenra cnoro'i tapla",
  "block.minecraft.cracked_nether_bricks": "selfenra ke dzimu'e kubli bliku",
  "block.minecraft.cracked_polished_blackstone_bricks": "selfenra ke selspali xekro'i bliku",
  "block.minecraft.cracked_stone_bricks": "fenra ke rokci bliku",
  "block.minecraft.crafter": "zbasu",
  "block.minecraft.crafting_table": "zbasu jubme",
  "block.minecraft.creaking_heart": "lo risna be lo vrumli cizda'u",
  "block.minecraft.creeper_head": "stedu be la .kripr.",
  "block.minecraft.creeper_wall_head": "stedu pe la .kriper. be ne'a bitmu",
  "block.minecraft.crimson_button": "zirxu'e batke",
  "block.minecraft.crimson_door": "zirxu'e vrogai",
  "block.minecraft.crimson_fence": "zirxu'e garbi'u",
  "block.minecraft.crimson_fence_gate": "zirxu'e garbimvrogai",
  "block.minecraft.crimson_fungus": "zirxu'e gumri",
  "block.minecraft.crimson_hanging_sign": "zirxu'e ke dandu lertapla",
  "block.minecraft.crimson_hyphae": "zirxu'e ledju'e",
  "block.minecraft.crimson_nylium": "zirxu'e ledyclika",
  "block.minecraft.crimson_planks": "zirxu'e tanbo",
  "block.minecraft.crimson_pressure_plate": "zirxu'e danrytapla",
  "block.minecraft.crimson_roots": "zirxu'e genja",
  "block.minecraft.crimson_shelf": "zirxu'e kajna",
  "block.minecraft.crimson_sign": "zirxu'e lertapla",
  "block.minecraft.crimson_slab": "zirxu'e xabybli",
  "block.minecraft.crimson_stairs": "zirxu'e serti",
  "block.minecraft.crimson_stem": "zirxu'e stani",
  "block.minecraft.crimson_trapdoor": "zirxu'e lolvrogai",
  "block.minecraft.crimson_wall_hanging_sign": "bitmu ke zirxu'e ke dandu lertapla",
  "block.minecraft.crimson_wall_sign": "bi'uzva ke zirxu'e lertapla",
  "block.minecraft.crying_obsidian": "klaku fagblaci",
  "block.minecraft.cut_copper": "selsraku ke tunka bliku",
  "block.minecraft.cut_copper_slab": "selsraku ke tunka xabybli",
  "block.minecraft.cut_copper_stairs": "selsraku ke tunka serti",
  "block.minecraft.cut_red_sandstone": "selka'a xunre canro'i",
  "block.minecraft.cut_red_sandstone_slab": "selka'a xunre bo canro'i xabybli",
  "block.minecraft.cut_sandstone": "selka'a canro'i",
  "block.minecraft.cut_sandstone_slab": "selka'a canro'i xabybli",
  "block.minecraft.cyan_banner": "cicna srilanci",
  "block.minecraft.cyan_bed": "cicna ckana",
  "block.minecraft.cyan_candle": "cicna laktergu'i",
  "block.minecraft.cyan_candle_cake": "cicna laktergu'i kenka",
  "block.minecraft.cyan_carpet": "cicna buklolgai",
  "block.minecraft.cyan_concrete": "cicna xumrkonkreto",
  "block.minecraft.cyan_concrete_powder": "cicna xumrkonkreto purmo",
  "block.minecraft.cyan_glazed_terracotta": "le cicna stakrterakota poi se fagri",
  "block.minecraft.cyan_shulker_box": "cicna ke me la .cylkr. tanxe",
  "block.minecraft.cyan_stained_glass": "cicna skari blaci",
  "block.minecraft.cyan_stained_glass_pane": "cicna skari canko blaci",
  "block.minecraft.cyan_terracotta": "cicna stakrterakota",
  "block.minecraft.cyan_wool": "cicna sunla",
  "block.minecraft.damaged_anvil": "selxai jimda'izbe",
  "block.minecraft.dandelion": "spartaraksaku",
  "block.minecraft.dark_oak_button": "mancindu batke",
  "block.minecraft.dark_oak_door": "mancindu vrogai",
  "block.minecraft.dark_oak_fence": "mancindu garbi'u",
  "block.minecraft.dark_oak_fence_gate": "mancindu garbimvrogai",
  "block.minecraft.dark_oak_hanging_sign": "mancindu ke dandu lertapla",
  "block.minecraft.dark_oak_leaves": "mancindu pezli",
  "block.minecraft.dark_oak_log": "mancindu stani",
  "block.minecraft.dark_oak_planks": "mancindu tanbo",
  "block.minecraft.dark_oak_pressure_plate": "lo mancindu danrytapla",
  "block.minecraft.dark_oak_sapling": "mancindu ciftricu",
  "block.minecraft.dark_oak_shelf": "mancindu kajna",
  "block.minecraft.dark_oak_sign": "mancindu sinxa",
  "block.minecraft.dark_oak_slab": "mancindu xabybli",
  "block.minecraft.dark_oak_stairs": "mancindu serti",
  "block.minecraft.dark_oak_trapdoor": "mancindu lolvrogai",
  "block.minecraft.dark_oak_wall_hanging_sign": "bitmu ke mancindu ke dandu lertapla",
  "block.minecraft.dark_oak_wall_sign": "mancindu ke bitmu lertapla",
  "block.minecraft.dark_oak_wood": "mancindu mudri",
  "block.minecraft.dark_prismarine": "manku prismarine",
  "block.minecraft.dark_prismarine_slab": "manku prismarine xabybli",
  "block.minecraft.dark_prismarine_stairs": "manserti be me la prismarin.",
  "block.minecraft.daylight_detector": "tangu'i ganse",
  "block.minecraft.dead_brain_coral": "Dead Brain Coral",
  "block.minecraft.dead_brain_coral_block": "morsi ke bentai ricnritrina bliku",
  "block.minecraft.dead_brain_coral_fan": "morsi ke bentai ricnritrina tolfalnu",
  "block.minecraft.dead_brain_coral_wall_fan": "morsi ke bentai ricnritrina bimtolfalnu",
  "block.minecraft.dead_bubble_coral": "Dead Bubble Coral",
  "block.minecraft.dead_bubble_coral_block": "mrosi ke fomtai ricnritrina bliku",
  "block.minecraft.dead_bubble_coral_fan": "morsi ke fomtai ricnritrina tolfalnu",
  "block.minecraft.dead_bubble_coral_wall_fan": "morsi ke fomtai ricnritrina bimtolfalnu",
  "block.minecraft.dead_bush": "morsi dzitricu",
  "block.minecraft.dead_fire_coral": "Dead Fire Coral",
  "block.minecraft.dead_fire_coral_block": "morsi ke fagtai ricnritrina bliku",
  "block.minecraft.dead_fire_coral_fan": "morsi ke fagtai ricnritrina tolfalnu",
  "block.minecraft.dead_fire_coral_wall_fan": "morsi ke fagtai ricnritrina bimtolfalnu",
  "block.minecraft.dead_horn_coral": "Dead Horn Coral",
  "block.minecraft.dead_horn_coral_block": "morsi ke jirnytai ricnritrina bliku",
  "block.minecraft.dead_horn_coral_fan": "morsi ke jirnytai ricnritrina tolfalnu",
  "block.minecraft.dead_horn_coral_wall_fan": "morsi ke jirnytai ricnritrina bimtolfalnu",
  "block.minecraft.dead_tube_coral": "Dead Tube Coral",
  "block.minecraft.dead_tube_coral_block": "morsi ke tu'urtai ricnritrina bliku",
  "block.minecraft.dead_tube_coral_fan": "morsi ke tu'urtai ricnritrina tolfalnu",
  "block.minecraft.dead_tube_coral_wall_fan": "morsi ke tu'urtai ricnritrina bimtolfalnu",
  "block.minecraft.decorated_pot": "selja'i patxu",
  "block.minecraft.deepslate": "cnoro'i",
  "block.minecraft.deepslate_brick_slab": "cnoro'i kitybli xabybli",
  "block.minecraft.deepslate_brick_stairs": "cnoro'i kitybli serti",
  "block.minecraft.deepslate_brick_wall": "cnoro'i kitybli bitmu",
  "block.minecraft.deepslate_bricks": "cnoro'i kitybli",
  "block.minecraft.deepslate_coal_ore": "cnoro'i ke kolme kunra",
  "block.minecraft.deepslate_copper_ore": "cnoro'i ke tunka kunra",
  "block.minecraft.deepslate_diamond_ore": "cnoro'i ke tabjme kunra",
  "block.minecraft.deepslate_emerald_ore": "cnoro'i ke ri'ojme kunra",
  "block.minecraft.deepslate_gold_ore": "cnoro'i ke solji kunra",
  "block.minecraft.deepslate_iron_ore": "cnoro'i ke tirse kunra",
  "block.minecraft.deepslate_lapis_ore": "cnoro'i ke blaro'i kunra",
  "block.minecraft.deepslate_redstone_ore": "cnoro'i ke me la redston. kunra",
  "block.minecraft.deepslate_tile_slab": "cnoro'i tapla xabybli",
  "block.minecraft.deepslate_tile_stairs": "cnoro'i tapla serti",
  "block.minecraft.deepslate_tile_wall": "cnoro'i tapla bitmu",
  "block.minecraft.deepslate_tiles": "cnoro'i tapla",
  "block.minecraft.detector_rail": "ganse tertrene",
  "block.minecraft.diamond_block": "tabjme bliku",
  "block.minecraft.diamond_ore": "tabjme kunra",
  "block.minecraft.diorite": "rokcrdi'ori",
  "block.minecraft.diorite_slab": "rokcrdi'ori xabybli",
  "block.minecraft.diorite_stairs": "rokcrdi'ori serti",
  "block.minecraft.diorite_wall": "rokcrdi'ori bitmu",
  "block.minecraft.dirt": "dertu",
  "block.minecraft.dirt_path": "derlu'a",
  "block.minecraft.dispenser": "dudzmi",
  "block.minecraft.dragon_egg": "drakono sovda",
  "block.minecraft.dragon_head": "lo stedu be lo drakono",
  "block.minecraft.dragon_wall_head": "drakono sedbo'u be ne'a bitmu",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "se sudgau vraike bliku",
  "block.minecraft.dripstone_block": "digyligykamju bliku",
  "block.minecraft.dropper": "falpu'i",
  "block.minecraft.emerald_block": "ri'ojme bliku",
  "block.minecraft.emerald_ore": "ri'ojme kunra",
  "block.minecraft.enchanting_table": "makfa jubme",
  "block.minecraft.end_gateway": ".endre vorme",
  "block.minecraft.end_portal": ".endre vorme",
  "block.minecraft.end_portal_frame": ".endre vorme greku",
  "block.minecraft.end_rod": ".endre grana",
  "block.minecraft.end_stone": ".endre rokci",
  "block.minecraft.end_stone_brick_slab": ".endre rokci bliku xabybli",
  "block.minecraft.end_stone_brick_stairs": "ke .endre rokci bliku ke'e serti",
  "block.minecraft.end_stone_brick_wall": ".endre rokci bliku bitmu",
  "block.minecraft.end_stone_bricks": ".endre rokci bliku",
  "block.minecraft.ender_chest": ".endre vasru",
  "block.minecraft.exposed_chiseled_copper": "pafi'uciva'e cicnybi'o ke selja'i ke tunka bliku",
  "block.minecraft.exposed_copper": "pafi'uciva'e cicnybi'o ke tunka bliku",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "pafi'uciva'e cicnybi'o ke tunka tergu'i",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "pafi'uciva'e cicnybi'o ke tunka vrogai",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "pafi'uciva'e cicnybi'o ke tunka ga'avro",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "pafi'uciva'e cicnybi'o ke tunka lolvrogai",
  "block.minecraft.exposed_cut_copper": "pafi'uciva'e cicnybi'o ke selsraku ke tunka bliku",
  "block.minecraft.exposed_cut_copper_slab": "pafi'uciva'e cicnybi'o ke selsraku ke tunka xabybli",
  "block.minecraft.exposed_cut_copper_stairs": "pafi'uciva'e cicnybi'o ke selsraku ke tunka serti",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "selcange",
  "block.minecraft.fern": "filcina",
  "block.minecraft.fire": "fagri",
  "block.minecraft.fire_coral": "fagtai ricnritrina",
  "block.minecraft.fire_coral_block": "fagtai ricnritrina bliku",
  "block.minecraft.fire_coral_fan": "fagtai ricnritrina tolfalnu",
  "block.minecraft.fire_coral_wall_fan": "fagtai ricnritrina bimtolfalnu",
  "block.minecraft.firefly_bush": "gusycinki dzitricu",
  "block.minecraft.fletching_table": "celga'azbajbu",
  "block.minecraft.flower_pot": "xrula patxu",
  "block.minecraft.flowering_azalea": "rulselpau ricnrododendro",
  "block.minecraft.flowering_azalea_leaves": "rulselpau ricnrododendro pezli",
  "block.minecraft.frogspawn": "pipybanfi fipso'a",
  "block.minecraft.frosted_ice": "selbislunsa bisli",
  "block.minecraft.furnace": "zbasu toknu",
  "block.minecraft.gilded_blackstone": "slovau xekro'i",
  "block.minecraft.glass": "blaci",
  "block.minecraft.glass_pane": "canko blaci",
  "block.minecraft.glow_lichen": "carmi clika",
  "block.minecraft.glowstone": "carmyro'i",
  "block.minecraft.gold_block": "solji bliku",
  "block.minecraft.gold_ore": "solji kunra",
  "block.minecraft.golden_dandelion": "solji spartaraksaku",
  "block.minecraft.granite": "rokcrgranu",
  "block.minecraft.granite_slab": "rokcrgranu xabybli",
  "block.minecraft.granite_stairs": "rokcrgranu serti",
  "block.minecraft.granite_wall": "rokcrgranu bitmu",
  "block.minecraft.grass": "srasu",
  "block.minecraft.grass_block": "srasu bliku",
  "block.minecraft.gravel": "rokci canre",
  "block.minecraft.gray_banner": "grusi srilanci",
  "block.minecraft.gray_bed": "grusi ckana",
  "block.minecraft.gray_candle": "grusi laktergu'i",
  "block.minecraft.gray_candle_cake": "grusi laktergu'i kenka",
  "block.minecraft.gray_carpet": "grusi buklolgai",
  "block.minecraft.gray_concrete": "grusi xumrkonkreto",
  "block.minecraft.gray_concrete_powder": "grusi xumrkonkreto purmo",
  "block.minecraft.gray_glazed_terracotta": "le grusi stakrterakota poi jelca",
  "block.minecraft.gray_shulker_box": "grusi ke me la .cylkr. tanxe",
  "block.minecraft.gray_stained_glass": "grusi skari blaci",
  "block.minecraft.gray_stained_glass_pane": "grusi skari canko blaci",
  "block.minecraft.gray_terracotta": "grusi stakrterakota",
  "block.minecraft.gray_wool": "grusi sunla",
  "block.minecraft.green_banner": "crino srilanci",
  "block.minecraft.green_bed": "crino ckana",
  "block.minecraft.green_candle": "crino laktergu'i",
  "block.minecraft.green_candle_cake": "crino laktergu'i kenka",
  "block.minecraft.green_carpet": "crino buklolgai",
  "block.minecraft.green_concrete": "crino xumrkonkreto",
  "block.minecraft.green_concrete_powder": "crino xumrkonkreto purmo",
  "block.minecraft.green_glazed_terracotta": "le crino stakrterakota poi se fagri",
  "block.minecraft.green_shulker_box": "crino ke me la .cylkr. tanxe",
  "block.minecraft.green_stained_glass": "crino skari blaci",
  "block.minecraft.green_stained_glass_pane": "crino skari canko blaci",
  "block.minecraft.green_terracotta": "crino stakrterakota",
  "block.minecraft.green_wool": "crino sunla",
  "block.minecraft.grindstone": "zalxi'u",
  "block.minecraft.hanging_roots": "dandu genja",
  "block.minecraft.hay_block": "sudysrasu bakfu",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "tilju danrytapla",
  "block.minecraft.honey_block": "melmi bliku",
  "block.minecraft.honeycomb_block": "biclakse bliku",
  "block.minecraft.hopper": "se'arko'u",
  "block.minecraft.horn_coral": "jirnytai ricnritrina",
  "block.minecraft.horn_coral_block": "jirnytai ricnritrina bliku",
  "block.minecraft.horn_coral_fan": "jirnytai ricnritrina tolfalnu",
  "block.minecraft.horn_coral_wall_fan": "jirnytai ricnritrina bimtolfalnu",
  "block.minecraft.ice": "bisli",
  "block.minecraft.infested_chiseled_stone_bricks": "cinki ke selja'i ke rokci kitybli",
  "block.minecraft.infested_cobblestone": "spirocki se infeste",
  "block.minecraft.infested_cracked_stone_bricks": "cinki ke fenra rokci kitybli",
  "block.minecraft.infested_deepslate": "malxa'u cnoro'i",
  "block.minecraft.infested_mossy_stone_bricks": "cinki ke clika rokci kitybli",
  "block.minecraft.infested_stone": "cinki rokci",
  "block.minecraft.infested_stone_bricks": "cinki ke rokci kitybli",
  "block.minecraft.iron_bars": "tirse garna",
  "block.minecraft.iron_block": "tirse bliku",
  "block.minecraft.iron_chain": "tirse linsi",
  "block.minecraft.iron_door": "tirse vrogai",
  "block.minecraft.iron_ore": "tirse kunra",
  "block.minecraft.iron_trapdoor": "tirse lolvrogai",
  "block.minecraft.jack_o_lantern": "selte'a guzmrkukurbita",
  "block.minecraft.jigsaw": "stura kruca bliku",
  "block.minecraft.jukebox": "zgike bliku",
  "block.minecraft.jungle_button": "cicricfoi batke",
  "block.minecraft.jungle_door": "cicricfoi vrogai",
  "block.minecraft.jungle_fence": "cicricfoi garbi'u",
  "block.minecraft.jungle_fence_gate": "cicricfoi garbimvrogai",
  "block.minecraft.jungle_hanging_sign": "cicricfoi ke dandu lertapla",
  "block.minecraft.jungle_leaves": "cicricfoi pezli",
  "block.minecraft.jungle_log": "cicricfoi stani",
  "block.minecraft.jungle_planks": "cicricfoi tanbo",
  "block.minecraft.jungle_pressure_plate": "cicricfoi danrytapla",
  "block.minecraft.jungle_sapling": "cicricfoi ciftricu",
  "block.minecraft.jungle_shelf": "cicricfoi kajna",
  "block.minecraft.jungle_sign": "cicricfoi mudri sinxa",
  "block.minecraft.jungle_slab": "cicricfoi xabybli",
  "block.minecraft.jungle_stairs": "cicricfoi serti",
  "block.minecraft.jungle_trapdoor": "cicricfoi lolvrogai",
  "block.minecraft.jungle_wall_hanging_sign": "bitmu ke cicricfoi ke dandu lertapla",
  "block.minecraft.jungle_wall_sign": "cicricfoi ke bitmu lertapla",
  "block.minecraft.jungle_wood": "cicricfoi mudri",
  "block.minecraft.kelp": "vraike",
  "block.minecraft.kelp_plant": "spati vraike",
  "block.minecraft.ladder": "rajyserti",
  "block.minecraft.lantern": "lanru",
  "block.minecraft.lapis_block": "blaro'i bliku",
  "block.minecraft.lapis_ore": "blaro'i kunra",
  "block.minecraft.large_amethyst_bud": "barda ke nalma'u .amtisti",
  "block.minecraft.large_fern": "barda filcina",
  "block.minecraft.lava": "rumro'i",
  "block.minecraft.lava_cauldron": "likro'i patxu",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "nunctuta'a jubme",
  "block.minecraft.lever": "vraga",
  "block.minecraft.light": "gusni",
  "block.minecraft.light_blue_banner": "labybla srilanci",
  "block.minecraft.light_blue_bed": "labybla ckana",
  "block.minecraft.light_blue_candle": "labybla laktergu'i",
  "block.minecraft.light_blue_candle_cake": "labybla laktergu'i kenka",
  "block.minecraft.light_blue_carpet": "labybla buklolgai",
  "block.minecraft.light_blue_concrete": "labybla xumrkonkreto",
  "block.minecraft.light_blue_concrete_powder": "labybla xumrkonkreto purmo",
  "block.minecraft.light_blue_glazed_terracotta": "le labybla stakrterakota poi se fagri",
  "block.minecraft.light_blue_shulker_box": "labybla ke me la .cylkr. tanxe",
  "block.minecraft.light_blue_stained_glass": "labybla skari blaci",
  "block.minecraft.light_blue_stained_glass_pane": "labybla skari canko blaci",
  "block.minecraft.light_blue_terracotta": "labybla stakrterakota",
  "block.minecraft.light_blue_wool": "labybla sunla",
  "block.minecraft.light_gray_banner": "labgrusi srilanci",
  "block.minecraft.light_gray_bed": "labgrusi ckana",
  "block.minecraft.light_gray_candle": "labyrus laktergu'i",
  "block.minecraft.light_gray_candle_cake": "labyrus laktergu'i kenka",
  "block.minecraft.light_gray_carpet": "labgrusi buklolgai",
  "block.minecraft.light_gray_concrete": "labgrusi xumrkonkreto",
  "block.minecraft.light_gray_concrete_powder": "labgrusi xumrkonkreto purmo",
  "block.minecraft.light_gray_glazed_terracotta": "le labyrus stakrterakota poi jelca",
  "block.minecraft.light_gray_shulker_box": "labgrusi ke me la .cylkr. tanxe",
  "block.minecraft.light_gray_stained_glass": "labgrusi skari blaci",
  "block.minecraft.light_gray_stained_glass_pane": "labgrusi skari canko blaci",
  "block.minecraft.light_gray_terracotta": "labgrusi stakrterakota",
  "block.minecraft.light_gray_wool": "labgrusi sunla",
  "block.minecraft.light_weighted_pressure_plate": "linto danrytapla",
  "block.minecraft.lightning_rod": "se lindi grana",
  "block.minecraft.lilac": "tricrsiringa",
  "block.minecraft.lily_of_the_valley": "linlani",
  "block.minecraft.lily_pad": "nimfaia",
  "block.minecraft.lime_banner": "labri'o srilanci",
  "block.minecraft.lime_bed": "labri'o ckana",
  "block.minecraft.lime_candle": "labri'o laktergu'i",
  "block.minecraft.lime_candle_cake": "labri'o laktergu'i kenka",
  "block.minecraft.lime_carpet": "labri'o lolgai",
  "block.minecraft.lime_concrete": "labri'o xumrkonkreto",
  "block.minecraft.lime_concrete_powder": "labri'o ke xumrkonkreto purmo",
  "block.minecraft.lime_glazed_terracotta": "labri'o ke blacyselgai stakrterakota",
  "block.minecraft.lime_shulker_box": "labri'o ke calkere tanxe",
  "block.minecraft.lime_stained_glass": "labri'o blaci",
  "block.minecraft.lime_stained_glass_pane": "labri'o ke canko blaci",
  "block.minecraft.lime_terracotta": "labri'o stakrterakota",
  "block.minecraft.lime_wool": "labri'o sunla",
  "block.minecraft.lodestone": "maksi",
  "block.minecraft.loom": "bukyzbami'i",
  "block.minecraft.magenta_banner": "nukni srilanci",
  "block.minecraft.magenta_bed": "nukni ckana",
  "block.minecraft.magenta_candle": "nukni laktergu'i",
  "block.minecraft.magenta_candle_cake": "nukni laktergu'i kenka",
  "block.minecraft.magenta_carpet": "nukni buklolgai",
  "block.minecraft.magenta_concrete": "nukni xumrkonkreto",
  "block.minecraft.magenta_concrete_powder": "nukni xumrkonkreto purmo",
  "block.minecraft.magenta_glazed_terracotta": "le nukni stakrterakota poi jelca",
  "block.minecraft.magenta_shulker_box": "nukni ke me la .cylkr. tanxe",
  "block.minecraft.magenta_stained_glass": "nukni skari blaci",
  "block.minecraft.magenta_stained_glass_pane": "nukni skari canko blaci",
  "block.minecraft.magenta_terracotta": "nukni stakrterakota",
  "block.minecraft.magenta_wool": "nukni sunla",
  "block.minecraft.magma_block": "rumro'i bliku",
  "block.minecraft.mangrove_button": "jiryricfoi batke",
  "block.minecraft.mangrove_door": "jiryricfoi vrogai",
  "block.minecraft.mangrove_fence": "jiryricfoi bitmu",
  "block.minecraft.mangrove_fence_gate": "jiryricfoi garbimvrogai",
  "block.minecraft.mangrove_hanging_sign": "jiryricfoi ke dandu lertapla",
  "block.minecraft.mangrove_leaves": "jiryricfoi pezli",
  "block.minecraft.mangrove_log": "jiryricfoi stani",
  "block.minecraft.mangrove_planks": "jiryricfoi tanbo",
  "block.minecraft.mangrove_pressure_plate": "jiryricfoi danrytapla",
  "block.minecraft.mangrove_propagule": "jiryricfoi ciftricu",
  "block.minecraft.mangrove_roots": "jiryricfoi genja",
  "block.minecraft.mangrove_shelf": "jiryricfoi kajna",
  "block.minecraft.mangrove_sign": "jiryricfoi lertapla",
  "block.minecraft.mangrove_slab": "jiryricfoi xabybli",
  "block.minecraft.mangrove_stairs": "jiryricfoi serti",
  "block.minecraft.mangrove_trapdoor": "jiryricfoi lolvrogai",
  "block.minecraft.mangrove_wall_hanging_sign": "bitmu ke jiryricfoi ke dandu lertapla",
  "block.minecraft.mangrove_wall_sign": "jiryricfoi ke bitmu lertapla",
  "block.minecraft.mangrove_wood": "jiryricfoi mudri",
  "block.minecraft.medium_amethyst_bud": "cnano ke nalma'u .amtisti",
  "block.minecraft.melon": "guzme",
  "block.minecraft.melon_stem": "guzme stani",
  "block.minecraft.moss_block": "clika bliku",
  "block.minecraft.moss_carpet": "clika lolgai",
  "block.minecraft.mossy_cobblestone": "clika spiro'i",
  "block.minecraft.mossy_cobblestone_slab": "clika spiro'i xabybli",
  "block.minecraft.mossy_cobblestone_stairs": "clika spiro'i serti",
  "block.minecraft.mossy_cobblestone_wall": "clika spiro'i bitmu",
  "block.minecraft.mossy_stone_brick_slab": "clika rokci bo bliku xabybli",
  "block.minecraft.mossy_stone_brick_stairs": "clika rokci bo bliku serti",
  "block.minecraft.mossy_stone_brick_wall": "clika rokci bo bliku bitmu",
  "block.minecraft.mossy_stone_bricks": "clika ke rokci bliku",
  "block.minecraft.moving_piston": "muvdu catke",
  "block.minecraft.mud": "derpesxu",
  "block.minecraft.mud_brick_slab": "derpesxu bliku xabybli",
  "block.minecraft.mud_brick_stairs": "derpesxu bliku serti",
  "block.minecraft.mud_brick_wall": "derpesxu bliku bitmu",
  "block.minecraft.mud_bricks": "derpesxu kitybli",
  "block.minecraft.muddy_mangrove_roots": "derpesxu ke jiryricfoi genja",
  "block.minecraft.mushroom_stem": "gumri stani",
  "block.minecraft.mycelium": "mledi",
  "block.minecraft.nether_brick_fence": "la me neter. kitybli garbi'u",
  "block.minecraft.nether_brick_slab": "la me neter. xabybli",
  "block.minecraft.nether_brick_stairs": "la me neter. kitybli serti",
  "block.minecraft.nether_brick_wall": "la me neter. kitybli bitmu",
  "block.minecraft.nether_bricks": "blikrne'eri",
  "block.minecraft.nether_gold_ore": "me la .ne'er. solji kunra",
  "block.minecraft.nether_portal": "palci canko",
  "block.minecraft.nether_quartz_ore": "krilrkartso kunra",
  "block.minecraft.nether_sprouts": "dzimu'e cifspa",
  "block.minecraft.nether_wart": "me la neter. spati",
  "block.minecraft.nether_wart_block": "me la neter. spati bliku",
  "block.minecraft.netherite_block": "dzimujyjinme bliku",
  "block.minecraft.netherrack": "me la neterak.",
  "block.minecraft.note_block": "tonga bliku",
  "block.minecraft.oak_button": "cindu batke",
  "block.minecraft.oak_door": "cindu vrogai",
  "block.minecraft.oak_fence": "cindu garbi'u",
  "block.minecraft.oak_fence_gate": "cindu garbimvrogai",
  "block.minecraft.oak_hanging_sign": "cindu ke dandu lertapla",
  "block.minecraft.oak_leaves": "cindu pezli",
  "block.minecraft.oak_log": "cindu stani",
  "block.minecraft.oak_planks": "cindu tanbo",
  "block.minecraft.oak_pressure_plate": "cindu danrytapla",
  "block.minecraft.oak_sapling": "cindu ciftricu",
  "block.minecraft.oak_shelf": "cindu kajna",
  "block.minecraft.oak_sign": "cindu sinxa",
  "block.minecraft.oak_slab": "cindu xabybli",
  "block.minecraft.oak_stairs": "cindu serti",
  "block.minecraft.oak_trapdoor": "cindu lolvrogai",
  "block.minecraft.oak_wall_hanging_sign": "bitmu ke cindu ke dandu lertapla",
  "block.minecraft.oak_wall_sign": "cindu ke bitmu lertapla",
  "block.minecraft.oak_wood": "cindu mudri",
  "block.minecraft.observer": "zgana",
  "block.minecraft.obsidian": "fagblaci",
  "block.minecraft.ochre_froglight": "burpelxu pipybanfytergu'i",
  "block.minecraft.ominous_banner": "ckape lanci",
  "block.minecraft.open_eyeblossom": "kalri kalxrula",
  "block.minecraft.orange_banner": "narju srilanci",
  "block.minecraft.orange_bed": "narju ckana",
  "block.minecraft.orange_candle": "narju laktergu'i",
  "block.minecraft.orange_candle_cake": "narji laktergu'i kenka",
  "block.minecraft.orange_carpet": "narju buklolgai",
  "block.minecraft.orange_concrete": "narju xumrkonkreto",
  "block.minecraft.orange_concrete_powder": "narju xumrkonkreto purmo",
  "block.minecraft.orange_glazed_terracotta": "le narju stakrterakota poi se fagri",
  "block.minecraft.orange_shulker_box": "narju ke me la .cylkr. tanxe",
  "block.minecraft.orange_stained_glass": "narju skari blaci",
  "block.minecraft.orange_stained_glass_pane": "narju skari canko blaci",
  "block.minecraft.orange_terracotta": "narju stakrterakota",
  "block.minecraft.orange_tulip": "narju tujli",
  "block.minecraft.orange_wool": "narju sunla",
  "block.minecraft.oxeye_daisy": "sparbeli",
  "block.minecraft.oxidized_chiseled_copper": "cifi'uciva'e cicnybi'o ke selja'i ke tunka bliku",
  "block.minecraft.oxidized_copper": "cifi'uciva'e cicnybi'o ke tunka bliku",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "cifi'uciva'e cicnybi'o ke tunka tergu'i",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "cifi'uciva'e cicnybi'o ke tunka vrogai",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "cifi'uciva'e cicnybi'o ke tunka ga'avro",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "cifi'uciva'e cicnybi'o ke tunka lolvrogai",
  "block.minecraft.oxidized_cut_copper": "cifi'uciva'e cicnybi'o ke selsraku ke tunka bliku",
  "block.minecraft.oxidized_cut_copper_slab": "cifi'uciva'e cicnybi'o ke selsraku ke tunka xabybli",
  "block.minecraft.oxidized_cut_copper_stairs": "cifi'uciva'e cicnybi'o ke selsraku ke tunka serti",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "demri'a bisli",
  "block.minecraft.packed_mud": "demri'a derpesxu",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "kadycindu batke",
  "block.minecraft.pale_oak_door": "kadycindu vrogai",
  "block.minecraft.pale_oak_fence": "kadycindu garbi'u",
  "block.minecraft.pale_oak_fence_gate": "kadycindu garbimvrogai",
  "block.minecraft.pale_oak_hanging_sign": "kadycindu ke dandu lertapla",
  "block.minecraft.pale_oak_leaves": "kadycindu pezli",
  "block.minecraft.pale_oak_log": "kadycindu stani",
  "block.minecraft.pale_oak_planks": "kadycindu tanbo",
  "block.minecraft.pale_oak_pressure_plate": "kadycindu danrytapla",
  "block.minecraft.pale_oak_sapling": "kadycindu ciftricu",
  "block.minecraft.pale_oak_shelf": "kadycindu kajna",
  "block.minecraft.pale_oak_sign": "kadycindu lertapla",
  "block.minecraft.pale_oak_slab": "kadycindu xabybli",
  "block.minecraft.pale_oak_stairs": "kadycindu serti",
  "block.minecraft.pale_oak_trapdoor": "kadycindu lolvrogai",
  "block.minecraft.pale_oak_wall_hanging_sign": "bitmu ke kadycindu ke dandu lertapla",
  "block.minecraft.pale_oak_wall_sign": "kadycindu ke bitmu lertapla",
  "block.minecraft.pale_oak_wood": "kadycindu mudri",
  "block.minecraft.pearlescent_froglight": "cakyjmepi'a pipybanfytergu'i",
  "block.minecraft.peony": "xunblabi xrula",
  "block.minecraft.petrified_oak_slab": "se rokygau cindu xabybli",
  "block.minecraft.piglin_head": "stedu be la .piglin.",
  "block.minecraft.piglin_wall_head": "stedu be la .piglin. bei ne'a lo bitmu",
  "block.minecraft.pink_banner": "penka srilanci",
  "block.minecraft.pink_bed": "xunblabi ckana",
  "block.minecraft.pink_candle": "penka laktergu'i",
  "block.minecraft.pink_candle_cake": "penka laktergu'i kenka",
  "block.minecraft.pink_carpet": "penka lolgai",
  "block.minecraft.pink_concrete": "xunblabi xumrkonkreto",
  "block.minecraft.pink_concrete_powder": "xunblabi xumrkonkreto purmo",
  "block.minecraft.pink_glazed_terracotta": "le xunblabi stakrterakota poi se fagri",
  "block.minecraft.pink_petals": "penka rulpezli",
  "block.minecraft.pink_shulker_box": "labnukni ke me la .cylkr. tanxe",
  "block.minecraft.pink_stained_glass": "xunblabi skari blaci",
  "block.minecraft.pink_stained_glass_pane": "penka skari canko blaci",
  "block.minecraft.pink_terracotta": "xunblabi stakrterakota",
  "block.minecraft.pink_tulip": "xunblabi tujli",
  "block.minecraft.pink_wool": "labnukni sunla",
  "block.minecraft.piston": "ca'erslanu",
  "block.minecraft.piston_head": "catke stedu",
  "block.minecraft.pitcher_crop": "paxspa spati",
  "block.minecraft.pitcher_plant": "paxspa",
  "block.minecraft.player_head": "stedu be lo kelci",
  "block.minecraft.player_head.named": "stedu be la'oi %s",
  "block.minecraft.player_wall_head": "kelci sedbo'u be ne'a bitmu",
  "block.minecraft.podzol": "dertrpodzo",
  "block.minecraft.pointed_dripstone": "digyligykamju",
  "block.minecraft.polished_andesite": "se spali rokcrande'i",
  "block.minecraft.polished_andesite_slab": "selspali rokcrande'i xabybli",
  "block.minecraft.polished_andesite_stairs": "se spali rokcrande'i serti",
  "block.minecraft.polished_basalt": "se spali kamjyro'i",
  "block.minecraft.polished_blackstone": "selspali xekro'i",
  "block.minecraft.polished_blackstone_brick_slab": "selspali xekro'i kubli xabybli",
  "block.minecraft.polished_blackstone_brick_stairs": "selspali xekro'i kubli serti",
  "block.minecraft.polished_blackstone_brick_wall": "selspali xekro'i kubli bitmu",
  "block.minecraft.polished_blackstone_bricks": "selspali xekro'i kubli bliku",
  "block.minecraft.polished_blackstone_button": "selspali xekro'i batke",
  "block.minecraft.polished_blackstone_pressure_plate": "selspali xekro'i danrytapla",
  "block.minecraft.polished_blackstone_slab": "selspali xekro'i xabybli",
  "block.minecraft.polished_blackstone_stairs": "selspali xekro'i serti",
  "block.minecraft.polished_blackstone_wall": "selspali xekro'i bitmu",
  "block.minecraft.polished_deepslate": "xutla cnoro'i",
  "block.minecraft.polished_deepslate_slab": "xutla cnoro'i xabybli",
  "block.minecraft.polished_deepslate_stairs": "xutla cnoro'i serti",
  "block.minecraft.polished_deepslate_wall": "xutla cnoro'i bitmu",
  "block.minecraft.polished_diorite": "se spali rokcrdi'ori",
  "block.minecraft.polished_diorite_slab": "selspali rokcrdi'ori xabybli",
  "block.minecraft.polished_diorite_stairs": "se spali rokcrdi'ori serti",
  "block.minecraft.polished_granite": "se spali rokcrgranu",
  "block.minecraft.polished_granite_slab": "selspali rokcrgranu xabybli",
  "block.minecraft.polished_granite_stairs": "se spali rokcrgranu serti",
  "block.minecraft.polished_tuff": "selspali fagma'apucro'i",
  "block.minecraft.polished_tuff_slab": "selspali fagma'apucro'i xabybli",
  "block.minecraft.polished_tuff_stairs": "selspali fagma'apucro'i serti",
  "block.minecraft.polished_tuff_wall": "selspali fagma'apucro'i bitmu",
  "block.minecraft.poppy": "makpapi",
  "block.minecraft.potatoes": "patlu",
  "block.minecraft.potted_acacia_sapling": "paxne'i ke .atkaciia ciftricu",
  "block.minecraft.potted_allium": "paxne'i citsluni",
  "block.minecraft.potted_azalea_bush": "paxne'i ricnrododendro",
  "block.minecraft.potted_azure_bluet": "paxne'i cmablabyxrula",
  "block.minecraft.potted_bamboo": "paxne'i bambu",
  "block.minecraft.potted_birch_sapling": "paxne'i ke .eptula ciftricu",
  "block.minecraft.potted_blue_orchid": "paxne'i blalarki",
  "block.minecraft.potted_brown_mushroom": "paxne'i ke bunre gumri",
  "block.minecraft.potted_cactus": "paxne'i jesyspa",
  "block.minecraft.potted_cherry_sapling": "paxne'i ke ricrceraso ciftricu",
  "block.minecraft.potted_closed_eyeblossom": "paxne'i ke ganlo kalxrula",
  "block.minecraft.potted_cornflower": "paxne'i centaureia",
  "block.minecraft.potted_crimson_fungus": "paxne'i ke zirxu'e gumri",
  "block.minecraft.potted_crimson_roots": "paxne'i ke zirxu'e genja",
  "block.minecraft.potted_dandelion": "paxne'i spartaraksaku",
  "block.minecraft.potted_dark_oak_sapling": "paxne'i ke mancindu ciftricu",
  "block.minecraft.potted_dead_bush": "paxne'i ke morsi dzitricu",
  "block.minecraft.potted_fern": "paxne'i filcina",
  "block.minecraft.potted_flowering_azalea_bush": "paxne'i ke rulselpau ricnrododendro",
  "block.minecraft.potted_golden_dandelion": "paxne'i ke solji spartaraksaku",
  "block.minecraft.potted_jungle_sapling": "paxne'i ke cicricfoi ciftricu",
  "block.minecraft.potted_lily_of_the_valley": "paxne'i linlani",
  "block.minecraft.potted_mangrove_propagule": "paxne'i ke jiryricfoi ciftricu",
  "block.minecraft.potted_oak_sapling": "paxne'i ke cindu ciftricu",
  "block.minecraft.potted_open_eyeblossom": "paxne'i ke kalri kalxrula",
  "block.minecraft.potted_orange_tulip": "paxne'i ke narju tujli",
  "block.minecraft.potted_oxeye_daisy": "paxne'i ke sparbeli",
  "block.minecraft.potted_pale_oak_sapling": "paxne'i ke kadycindu ciftricu",
  "block.minecraft.potted_pink_tulip": "paxne'i ke penka tujli",
  "block.minecraft.potted_poppy": "paxne'i makpapi",
  "block.minecraft.potted_red_mushroom": "paxne'i ke xunre gumri",
  "block.minecraft.potted_red_tulip": "paxne'i ke xunre tujli",
  "block.minecraft.potted_spruce_sapling": "paxne'i ke ckunu ciftricu",
  "block.minecraft.potted_torchflower": "paxne'i fagytergusxrula",
  "block.minecraft.potted_warped_fungus": "paxne'i ke cizra gumri",
  "block.minecraft.potted_warped_roots": "paxne'i ke cizra genja",
  "block.minecraft.potted_white_tulip": "paxne'i ke blabi tujli",
  "block.minecraft.potted_wither_rose": "paxne'i ke me la .uiter. xrula",
  "block.minecraft.powder_snow": "pumsi'e",
  "block.minecraft.powder_snow_cauldron": "pumsi'e patxu",
  "block.minecraft.powered_rail": "dikca tertrene",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_brick_slab": "prismarine kitybli xabybli",
  "block.minecraft.prismarine_brick_stairs": "prismarine kitybli serti",
  "block.minecraft.prismarine_bricks": "prismarine kitybli",
  "block.minecraft.prismarine_slab": "prismarine xabybli",
  "block.minecraft.prismarine_stairs": "prismarine serti",
  "block.minecraft.prismarine_wall": "prismarine bitmu",
  "block.minecraft.pumpkin": "guzmrkukurbita",
  "block.minecraft.pumpkin_stem": "guzmrkukurbita stani",
  "block.minecraft.purple_banner": "zirpu srilanci",
  "block.minecraft.purple_bed": "zirpu ckana",
  "block.minecraft.purple_candle": "zirpu laktergu'i",
  "block.minecraft.purple_candle_cake": "zirpu laktergu'i kenka",
  "block.minecraft.purple_carpet": "zirpu buklolgai",
  "block.minecraft.purple_concrete": "zirpu xumrkonkreto",
  "block.minecraft.purple_concrete_powder": "zirpu xumrkonkreto purmo",
  "block.minecraft.purple_glazed_terracotta": "le zirpu stakrterakota poi jelca",
  "block.minecraft.purple_shulker_box": "zirpu ke me la .cylkr. tanxe",
  "block.minecraft.purple_stained_glass": "zirpu skari blaci",
  "block.minecraft.purple_stained_glass_pane": "zirpu skari canko blaci",
  "block.minecraft.purple_terracotta": "zirpu stakrterakota",
  "block.minecraft.purple_wool": "zirpu sunla",
  "block.minecraft.purpur_block": "purpura bliku",
  "block.minecraft.purpur_pillar": "purpura kamju",
  "block.minecraft.purpur_slab": "purpura xabybli",
  "block.minecraft.purpur_stairs": "purpura serti",
  "block.minecraft.quartz_block": "krili bliku",
  "block.minecraft.quartz_bricks": "krilrkartso kubli bliku",
  "block.minecraft.quartz_pillar": "krilrkartso kamju",
  "block.minecraft.quartz_slab": "krilrkartso xabybli",
  "block.minecraft.quartz_stairs": "krili serti",
  "block.minecraft.rail": "tertrene",
  "block.minecraft.raw_copper_block": "nalselrucyzu'e tunka bliku",
  "block.minecraft.raw_gold_block": "nalselrucyzu'e solji bliku",
  "block.minecraft.raw_iron_block": "nalselrucyzu'e tirse bliku",
  "block.minecraft.red_banner": "xukmi srilanci",
  "block.minecraft.red_bed": "xunre ckana",
  "block.minecraft.red_candle": "xunre laktergu'i",
  "block.minecraft.red_candle_cake": "xunre laktergu'i kenka",
  "block.minecraft.red_carpet": "xunre buklolgai",
  "block.minecraft.red_concrete": "xunre xumrkonkreto",
  "block.minecraft.red_concrete_powder": "xunre xumrkonkreto purmo",
  "block.minecraft.red_glazed_terracotta": "le xunre stakrterakota poi jelca",
  "block.minecraft.red_mushroom": "xunre gumri",
  "block.minecraft.red_mushroom_block": "xunre gumri bliku",
  "block.minecraft.red_nether_brick_slab": "xunre me la neter. bo bliku xabybli",
  "block.minecraft.red_nether_brick_stairs": "xunre me la .neter. bo bliku serti",
  "block.minecraft.red_nether_brick_wall": "xunre me la neter. kitybli bitmu",
  "block.minecraft.red_nether_bricks": "la me neter.kitybli co xunre",
  "block.minecraft.red_sand": "xunre canre",
  "block.minecraft.red_sandstone": "xunre canre rokci",
  "block.minecraft.red_sandstone_slab": "xunre canro'i xabybli",
  "block.minecraft.red_sandstone_stairs": "xunre canre rokci serti",
  "block.minecraft.red_sandstone_wall": "xunre canro'i bitmu",
  "block.minecraft.red_shulker_box": "xunre ke me la .cylkr. tanxe",
  "block.minecraft.red_stained_glass": "xunre skari blaci",
  "block.minecraft.red_stained_glass_pane": "xunre skari canko blaci",
  "block.minecraft.red_terracotta": "xunre stakrterakota",
  "block.minecraft.red_tulip": "xunre tujli",
  "block.minecraft.red_wool": "xunre sunla",
  "block.minecraft.redstone_block": "me la redston. bliku",
  "block.minecraft.redstone_lamp": "me la redston. tergu'i",
  "block.minecraft.redstone_ore": "me la redston. kunra",
  "block.minecraft.redstone_torch": "me la redston. fagytergu'i",
  "block.minecraft.redstone_wall_torch": "bi'uzva ke xunpu'o fagytergu'i",
  "block.minecraft.redstone_wire": "me la redston cilta",
  "block.minecraft.reinforced_deepslate": "tsali cnoro'i",
  "block.minecraft.repeater": "me la redston. bejrapli",
  "block.minecraft.repeating_command_block": "rapli ziltinbe bliku",
  "block.minecraft.resin_block": "gomja bliku",
  "block.minecraft.resin_brick_slab": "gomja kubli xabybli",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "gomja kubli bliku",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "rapyjbe tutci",
  "block.minecraft.rooted_dirt": "genja dertu",
  "block.minecraft.rose_bush": "dzitricu rozgu",
  "block.minecraft.sand": "canre",
  "block.minecraft.sandstone": "canro'i",
  "block.minecraft.sandstone_slab": "canro'i xabybli",
  "block.minecraft.sandstone_stairs": "canro'i serti",
  "block.minecraft.sandstone_wall": "canro'i bitmu",
  "block.minecraft.scaffolding": "rajysra",
  "block.minecraft.sculk": "lo sculk",
  "block.minecraft.sculk_catalyst": "lo sculk blimajgau",
  "block.minecraft.sculk_sensor": "me la .skylk. ganse",
  "block.minecraft.sculk_shrieker": "lo sculk bliklacpe",
  "block.minecraft.sculk_vein": "lo sculk senta",
  "block.minecraft.sea_lantern": "xamsi gustci",
  "block.minecraft.sea_pickle": "xasyjirstagi",
  "block.minecraft.seagrass": "xasni'asrasu",
  "block.minecraft.set_spawn": ".i galfi lo veljbe",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "rajyto'u srasu",
  "block.minecraft.shroomlight": "ledytergu'i",
  "block.minecraft.shulker_box": "me la .cylkr. tanxe",
  "block.minecraft.skeleton_skull": "bogygreku sedbo'u",
  "block.minecraft.skeleton_wall_skull": "bogygreku sedbo'u be ne'a bitmu",
  "block.minecraft.slime_block": "jduli bliku",
  "block.minecraft.small_amethyst_bud": "cmalu ke nalma'u .amtisti",
  "block.minecraft.small_dripleaf": "cmalu sinpezli",
  "block.minecraft.smithing_table": "tcizbajbu",
  "block.minecraft.smoker": "damtoknu",
  "block.minecraft.smooth_basalt": "xutla kamjyro'i",
  "block.minecraft.smooth_quartz": "xutla krilrkartso",
  "block.minecraft.smooth_quartz_slab": "xutla krilrkartso xabybli",
  "block.minecraft.smooth_quartz_stairs": "xutla krilrkartso serti",
  "block.minecraft.smooth_red_sandstone": "xutla ke xunre canro'i",
  "block.minecraft.smooth_red_sandstone_slab": "xutla xunre bo canro'i xabybli",
  "block.minecraft.smooth_red_sandstone_stairs": "xutla xunre bo canro'i serti",
  "block.minecraft.smooth_sandstone": "xutla canro'i",
  "block.minecraft.smooth_sandstone_slab": "xutla canro'i xabybli",
  "block.minecraft.smooth_sandstone_stairs": "xutla canro'i serti",
  "block.minecraft.smooth_stone": "xutla rokci",
  "block.minecraft.smooth_stone_slab": "xutla rokci xabybli",
  "block.minecraft.sniffer_egg": "zbisakci sovda",
  "block.minecraft.snow": "snime",
  "block.minecraft.snow_block": "snime bliku",
  "block.minecraft.soul_campfire": "pruxi gikfagri",
  "block.minecraft.soul_fire": "ruxfagri",
  "block.minecraft.soul_lantern": "pruxi dadytergu'i",
  "block.minecraft.soul_sand": "pruxi canre",
  "block.minecraft.soul_soil": "pruxi dertu",
  "block.minecraft.soul_torch": "pruxi fagytergu'i",
  "block.minecraft.soul_wall_torch": "bi'uzva ke pruxi fagytergu'i",
  "block.minecraft.spawn.not_valid": ".i na ku do ckini lo ckana ja lo rapyjbe tutci vu'o poi na jai se zunti",
  "block.minecraft.spawner": "cupra be lo cizda'u",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "cuxna lo jmive jutsi",
  "block.minecraft.sponge": "panje",
  "block.minecraft.spore_blossom": "tsiju xrula",
  "block.minecraft.spruce_button": "ckunu batke",
  "block.minecraft.spruce_door": "ckunu vrogai",
  "block.minecraft.spruce_fence": "ckunu garbi'u",
  "block.minecraft.spruce_fence_gate": "ckunu garbimvrogai",
  "block.minecraft.spruce_hanging_sign": "ckunu ke dandu lertapla",
  "block.minecraft.spruce_leaves": "ckunu pezli",
  "block.minecraft.spruce_log": "ckunu stani",
  "block.minecraft.spruce_planks": "ckunu tanbo",
  "block.minecraft.spruce_pressure_plate": "ckunu danrytapla",
  "block.minecraft.spruce_sapling": "ckunu ciftricu",
  "block.minecraft.spruce_shelf": "ckunu kajna",
  "block.minecraft.spruce_sign": "ckunu lertapla",
  "block.minecraft.spruce_slab": "ckunu xabybli",
  "block.minecraft.spruce_stairs": "ckunu serti",
  "block.minecraft.spruce_trapdoor": "ckunu lolvrogai",
  "block.minecraft.spruce_wall_hanging_sign": "bitmu ke ckunu ke dandu lertapla",
  "block.minecraft.spruce_wall_sign": "ckunu ke bitmu lertapla",
  "block.minecraft.spruce_wood": "ckunu mudri",
  "block.minecraft.sticky_piston": "cpujveca'e",
  "block.minecraft.stone": "rokci",
  "block.minecraft.stone_brick_slab": "xutla rokci xabybli",
  "block.minecraft.stone_brick_stairs": "rokci serti",
  "block.minecraft.stone_brick_wall": "rocki bliku bitmu",
  "block.minecraft.stone_bricks": "rokci bliku",
  "block.minecraft.stone_button": "rokci batke",
  "block.minecraft.stone_pressure_plate": "rokci danrytapla",
  "block.minecraft.stone_slab": "rokci xabybli",
  "block.minecraft.stone_stairs": "rokci serti",
  "block.minecraft.stonecutter": "rokyka'a",
  "block.minecraft.stripped_acacia_log": "se pilvi'u .atkaciia",
  "block.minecraft.stripped_acacia_wood": "se pilvi'u ke .atkaciia mudri",
  "block.minecraft.stripped_bamboo_block": "se pilvi'u bambu bliku",
  "block.minecraft.stripped_birch_log": "se pilvi'u .eptula",
  "block.minecraft.stripped_birch_wood": "se pilvi'u ke .eptula mudri",
  "block.minecraft.stripped_cherry_log": "se pilvi'u ke ricrceraso stani",
  "block.minecraft.stripped_cherry_wood": "se pilvi'u ke ricrceraso mudri",
  "block.minecraft.stripped_crimson_hyphae": "pilcau ke zirxu'e ledju'e",
  "block.minecraft.stripped_crimson_stem": "pilcau ke zirxu'e stani",
  "block.minecraft.stripped_dark_oak_log": "se pilvi'u mancindu",
  "block.minecraft.stripped_dark_oak_wood": "se pilvi'u ke mancindu mudri",
  "block.minecraft.stripped_jungle_log": "se pilvi'u cicricfoi",
  "block.minecraft.stripped_jungle_wood": "se pilvi'u ke cicricfoi mudri",
  "block.minecraft.stripped_mangrove_log": "se pilvi'u jiryricfoi",
  "block.minecraft.stripped_mangrove_wood": "se pilvi'u ke jiryricfoi mudri",
  "block.minecraft.stripped_oak_log": "se pilvi'u cindu",
  "block.minecraft.stripped_oak_wood": "se pilvi'u ke cindu mudri",
  "block.minecraft.stripped_pale_oak_log": "se pilvi'u kadycindu",
  "block.minecraft.stripped_pale_oak_wood": "se pilvi'u ke kadycindu mudri",
  "block.minecraft.stripped_spruce_log": "se pilvi'u ckunu",
  "block.minecraft.stripped_spruce_wood": "se pilvi'u ke ckunu mudri",
  "block.minecraft.stripped_warped_hyphae": "pilcau ke cizra ledju'e",
  "block.minecraft.stripped_warped_stem": "pilcau ke cizra stani",
  "block.minecraft.structure_block": "dinju bliku",
  "block.minecraft.structure_void": "dinju kunti",
  "block.minecraft.sugar_cane": "sakta stani",
  "block.minecraft.sunflower": "solspa",
  "block.minecraft.suspicious_gravel": "selsenpi cmaro'i",
  "block.minecraft.suspicious_sand": "selsenpi canre",
  "block.minecraft.sweet_berry_bush": "jbari dzitricu",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "rajycla srasu",
  "block.minecraft.tall_seagrass": "clani xasni'asrasu",
  "block.minecraft.target": "teryre'o",
  "block.minecraft.terracotta": "stakrterakota",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "julne blaci",
  "block.minecraft.tnt": "jbama",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "fagytergu'i",
  "block.minecraft.torchflower": "fagytergusxrula",
  "block.minecraft.torchflower_crop": "fagytergusxrula velcange",
  "block.minecraft.trapped_chest": "terkavbu vasru",
  "block.minecraft.trial_spawner": "talsa cupra be lo cizda'u",
  "block.minecraft.tripwire": "terkavbu skori",
  "block.minecraft.tripwire_hook": "terkavbu genxu",
  "block.minecraft.tube_coral": "tu'urtai ricnritrina",
  "block.minecraft.tube_coral_block": "tu'urtai ricnritrina bliku",
  "block.minecraft.tube_coral_fan": "tu'urtai ricnritrina tolfalnu",
  "block.minecraft.tube_coral_wall_fan": "tu'urtai ricnritrina bimtolfalnu",
  "block.minecraft.tuff": "fagma'apucro'i",
  "block.minecraft.tuff_brick_slab": "fagma'apucro'i bliku xabybli",
  "block.minecraft.tuff_brick_stairs": "fagma'apucro'i bliku serti",
  "block.minecraft.tuff_brick_wall": "fagma'apucro'i bliku bitmu",
  "block.minecraft.tuff_bricks": "fagma'apucro'i bliku",
  "block.minecraft.tuff_slab": "fagma'apucro'i xabybli",
  "block.minecraft.tuff_stairs": "fagma'apucro'i serti",
  "block.minecraft.tuff_wall": "fagma'apucro'i bitmu",
  "block.minecraft.turtle_egg": "cakyrespa sovda",
  "block.minecraft.twisting_vines": "sarlu li'ante",
  "block.minecraft.twisting_vines_plant": "sarlu li'ante stani",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "crino pipybanfytergu'i",
  "block.minecraft.vine": "skospa",
  "block.minecraft.void_air": "Void Air",
  "block.minecraft.wall_torch": "bi'uzva fagytergu'i",
  "block.minecraft.warped_button": "cizra batke",
  "block.minecraft.warped_door": "cizra vrogai",
  "block.minecraft.warped_fence": "cizra garbi'u",
  "block.minecraft.warped_fence_gate": "cizra garbimvrogai",
  "block.minecraft.warped_fungus": "cizra gumri",
  "block.minecraft.warped_hanging_sign": "cizra ke dandu lertapla",
  "block.minecraft.warped_hyphae": "cizra ledju'e",
  "block.minecraft.warped_nylium": "cizra ledyclika",
  "block.minecraft.warped_planks": "cizra tanbo",
  "block.minecraft.warped_pressure_plate": "cizra danrytapla",
  "block.minecraft.warped_roots": "cizra genja",
  "block.minecraft.warped_shelf": "cizra kajna",
  "block.minecraft.warped_sign": "cizra lertapla",
  "block.minecraft.warped_slab": "cizra xabybli",
  "block.minecraft.warped_stairs": "cizra serti",
  "block.minecraft.warped_stem": "cizra stani",
  "block.minecraft.warped_trapdoor": "cizra lolvrogai",
  "block.minecraft.warped_wall_hanging_sign": "bitmu ke cizra ke dandu lertapla",
  "block.minecraft.warped_wall_sign": "bi'uzva ke cizra lertapla",
  "block.minecraft.warped_wart_block": "cizra malspa bliku",
  "block.minecraft.water": "djacu",
  "block.minecraft.water_cauldron": "djacu patxu",
  "block.minecraft.waxed_chiseled_copper": "lakterpu'i ke selja'i ke tunka bliku",
  "block.minecraft.waxed_copper_bars": "lakterpu'i ke tunka garna",
  "block.minecraft.waxed_copper_block": "lakterpu'i ke tunka bliku",
  "block.minecraft.waxed_copper_bulb": "lakterpu'i ke tunka tergu'i",
  "block.minecraft.waxed_copper_chain": "lakterpu'i ke tunka linsi",
  "block.minecraft.waxed_copper_chest": "lakterpu'i ke tunka vasru",
  "block.minecraft.waxed_copper_door": "lakterpu'i ke tunka vrogai",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "lakterpu'i ke tunka ga'avro",
  "block.minecraft.waxed_copper_lantern": "lakterpu'i ke tunka dadytergu'i",
  "block.minecraft.waxed_copper_trapdoor": "lakterpu'i ke tunka lolvrogai",
  "block.minecraft.waxed_cut_copper": "lakterpu'i ke selsraku ke tunka bliku",
  "block.minecraft.waxed_cut_copper_slab": "lakterpu'i ke selsraku ke tunka xabybli",
  "block.minecraft.waxed_cut_copper_stairs": "lakterpu'i ke selsraku ke tunka serti",
  "block.minecraft.waxed_exposed_chiseled_copper": "lakterpu'i ke pafi'uciva'e cicnybi'o ke selja'i ke tunka bliku",
  "block.minecraft.waxed_exposed_copper": "lakterpu'i ke pafi'uciva'e cicnybi'o ke tunka bliku",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "lakterpu'i ke pafi'uciva'e cicnybi'o ke tunka tergu'i",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "lakterpu'i ke pafi'uciva'e cicnybi'o ke tunka vrogai",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "lakterpu'i ke pafi'uciva'e cicnybi'o ke tunka ga'avro",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "lakterpu'i ke pafi'uciva'e cicnybi'o ke tunka lolvrogai",
  "block.minecraft.waxed_exposed_cut_copper": "lakterpu'i ke pafi'uciva'e cicnybi'o ke selsraku ke tunka bliku",
  "block.minecraft.waxed_exposed_cut_copper_slab": "lakterpu'i ke pafi'uciva'e cicnybi'o ke selsraku ke tunka xabybli",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "lakterpu'i ke pafi'uciva'e cicnybi'o ke selsraku ke tunka serti",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "lakterpu'i ke selylindi grana",
  "block.minecraft.waxed_oxidized_chiseled_copper": "lakterpu'i ke cifi'uciva'e cicnybi'o ke selja'i ke tunka bliku",
  "block.minecraft.waxed_oxidized_copper": "lakterpu'i ke cifi'uciva'e cicnybi'o ke tunka bliku",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "lakterpu'i ke cifi'uciva'e cicnybi'o ke tunka tergu'i",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "lakterpu'i ke cifi'uciva'e cicnybi'o ke tunka vrogai",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "lakterpu'i ke cifi'uciva'e cicnybi'o ke tunka ga'avro",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "lakterpu'i ke cifi'uciva'e cicnybi'o ke tunka lolvrogai",
  "block.minecraft.waxed_oxidized_cut_copper": "lakterpu'i ke cifi'uciva'e cicnybi'o ke selsraku ke tunka bliku",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "lakterpu'i ke cifi'uciva'e cicnybi'o ke selsraku ke tunka xabybli",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "lakterpu'i ke cifi'uciva'e cicnybi'o ke selsraku ke tunka serti",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "lakterpu'i ke refi'uciva'e cicnybi'o ke selja'i ke tunka bliku",
  "block.minecraft.waxed_weathered_copper": "lakterpu'i ke refi'uciva'e cicnybi'o ke tunka bliku",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "lakterpu'i ke refi'uciva'e cicnybi'o ke tunka tergu'i",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "lakterpu'i ke refi'uciva'e cicnybi'o ke tunka vrogai",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "lakterpu'i ke refi'uciva'e cicnybi'o ke tunka ga'avro",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "lakterpu'i ke refi'uciva'e cicnybi'o ke tunka lolvrogai",
  "block.minecraft.waxed_weathered_cut_copper": "lakterpu'i ke refi'uciva'e cicnybi'o ke selsraku ke tunka bliku",
  "block.minecraft.waxed_weathered_cut_copper_slab": "lakterpu'i ke refi'uciva'e cicnybi'o ke selsraku ke tunka xabybli",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "lakterpu'i ke refi'uciva'e cicnybi'o ke selsraku ke tunka serti",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "refi'uciva'e cicnybi'o ke selja'i ke tunka bliku",
  "block.minecraft.weathered_copper": "refi'uciva'e cicnybi'o ke tunka bliku",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "refi'uciva'e cicnybi'o ke tunka tergu'i",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "refi'uciva'e cicnybi'o ke tunka vrogai",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "refi'uciva'e cicnybi'o ke tunka ga'avro",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "refi'uciva'e cicnybi'o ke tunka lolvrogai",
  "block.minecraft.weathered_cut_copper": "refi'uciva'e cicnybi'o ke selsraku ke tunka bliku",
  "block.minecraft.weathered_cut_copper_slab": "refi'uciva'e cicnybi'o ke selsraku ke tunka xabybli",
  "block.minecraft.weathered_cut_copper_stairs": "refi'uciva'e cicnybi'o ke selsraku ke tunka serti",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "klaku li'ante",
  "block.minecraft.weeping_vines_plant": "klaku li'ante stani",
  "block.minecraft.wet_sponge": "cilmo panje",
  "block.minecraft.wheat": "selrepyxri",
  "block.minecraft.white_banner": "blabi srilanci",
  "block.minecraft.white_bed": "blabi ckana",
  "block.minecraft.white_candle": "blabi laktergu'i",
  "block.minecraft.white_candle_cake": "blabi laktergu'i kenka",
  "block.minecraft.white_carpet": "blabi buklolgai",
  "block.minecraft.white_concrete": "blabi xumrkonkreto",
  "block.minecraft.white_concrete_powder": "blabi xumrkonkreto purmo",
  "block.minecraft.white_glazed_terracotta": "le blabi stakrterakota poi se fagri",
  "block.minecraft.white_shulker_box": "blabi ke me la .cylkr. tanxe",
  "block.minecraft.white_stained_glass": "blabi skari blaci",
  "block.minecraft.white_stained_glass_pane": "blabi skari canko blaci",
  "block.minecraft.white_terracotta": "blabi stakrterakota",
  "block.minecraft.white_tulip": "blabi tujli",
  "block.minecraft.white_wool": "blabi sunla",
  "block.minecraft.wildflowers": "cicyxrula",
  "block.minecraft.wither_rose": "me la .uiter. xrula",
  "block.minecraft.wither_skeleton_skull": "la me witer. je stedu",
  "block.minecraft.wither_skeleton_wall_skull": "la me .uiter. je stedu be ne'a bitmu",
  "block.minecraft.yellow_banner": "pelxu srilanci",
  "block.minecraft.yellow_bed": "pelxu ckana",
  "block.minecraft.yellow_candle": "pelxu laktergu'i",
  "block.minecraft.yellow_candle_cake": "pelxu laktergu'i kenka",
  "block.minecraft.yellow_carpet": "pelxu buklolgai",
  "block.minecraft.yellow_concrete": "pelxu xumrkonkreto",
  "block.minecraft.yellow_concrete_powder": "pelxu xumrkonkreto purmo",
  "block.minecraft.yellow_glazed_terracotta": "le pelxu stakrterakota poi jelca",
  "block.minecraft.yellow_shulker_box": "pelxu ke me la .cylkr. tanxe",
  "block.minecraft.yellow_stained_glass": "pelxu skari blaci",
  "block.minecraft.yellow_stained_glass_pane": "pelxu skari canko blaci",
  "block.minecraft.yellow_terracotta": "pelxu stakrterakota",
  "block.minecraft.yellow_wool": "pelxu sunla",
  "block.minecraft.zombie_head": "mivmro stedu",
  "block.minecraft.zombie_wall_head": "bi'uzva ke mivmro stedu",
  "item.minecraft.acacia_boat": ".atkaciia bloti",
  "item.minecraft.acacia_chest_boat": ".atkaciia bloti joi vasru",
  "item.minecraft.allay_spawn_egg": "blapedvoi jbeso'a",
  "item.minecraft.amethyst_shard": ".amtisti selpo'i",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "fipkalte ke staku selpo'i",
  "item.minecraft.apple": "plise",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "bagycelpli ke staku selpo'i",
  "item.minecraft.armadillo_scute": "dapsodi piltapla",
  "item.minecraft.armadillo_spawn_egg": "dapsodi jbeso'a",
  "item.minecraft.armor_stand": "badycakyzbe",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "birlafti ke staku selpo'i",
  "item.minecraft.arrow": "celga'a",
  "item.minecraft.axolotl_bucket": ".aclotlu baktu",
  "item.minecraft.axolotl_spawn_egg": ".aclotlu jbeso'a",
  "item.minecraft.baked_potato": "seljukpa patlu",
  "item.minecraft.bamboo_chest_raft": "bambu pinblo joi vasru",
  "item.minecraft.bamboo_raft": "bambu pinblo",
  "item.minecraft.bat_spawn_egg": "volratcu jbeso'a",
  "item.minecraft.bee_spawn_egg": "bifce jbeso'a",
  "item.minecraft.beef": "nalseljukpa bakre'u",
  "item.minecraft.beetroot": "spatrtensai",
  "item.minecraft.beetroot_seeds": "spatrtensai tsiju",
  "item.minecraft.beetroot_soup": "spatrtensai stasu",
  "item.minecraft.birch_boat": ".eptula bloti",
  "item.minecraft.birch_chest_boat": ".eptula bloti joi vasru",
  "item.minecraft.black_bundle": "xekri bafydakli",
  "item.minecraft.black_dye": "xekri xinmo",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "balre ke staku selpo'i",
  "item.minecraft.blaze_powder": "fagri purmo",
  "item.minecraft.blaze_rod": "fagri grana",
  "item.minecraft.blaze_spawn_egg": "fagda'u jbeso'a",
  "item.minecraft.blue_bundle": "blanu bafydakli",
  "item.minecraft.blue_dye": "blanu xinmo",
  "item.minecraft.blue_egg": "blanu sovda",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "bongu",
  "item.minecraft.bone_meal": "bongu purmo",
  "item.minecraft.book": "cukta",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "bagyce'a",
  "item.minecraft.bowl": "kabri",
  "item.minecraft.bread": "nanba",
  "item.minecraft.breeze_rod": "bifyda'u grana",
  "item.minecraft.breeze_spawn_egg": "bifyda'u jbeso'a",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "birjyzba ke staku selpo'i",
  "item.minecraft.brewing_stand": "Brewing Stand",
  "item.minecraft.brick": "kitybli",
  "item.minecraft.brown_bundle": "bunre bafydakli",
  "item.minecraft.brown_dye": "bunre xinmo",
  "item.minecraft.brown_egg": "bunre sovda",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "burcu",
  "item.minecraft.bucket": "baktu",
  "item.minecraft.bundle": "bafydakli",
  "item.minecraft.bundle.empty": "kunti",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "culno",
  "item.minecraft.bundle.fullness": "%s fi'u %s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "jelca ke staku selpo'i",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "rabykumte jbeso'a",
  "item.minecraft.carrot": "najgenja",
  "item.minecraft.carrot_on_a_stick": "najgenja co jorne be lo grana",
  "item.minecraft.cat_spawn_egg": "mlatu jbeso'a",
  "item.minecraft.cauldron": "patxu",
  "item.minecraft.cave_spider_spawn_egg": "kevjukni jbeso'a",
  "item.minecraft.chainmail_boots": "linsi badycutci",
  "item.minecraft.chainmail_chestplate": "linsi badycreka",
  "item.minecraft.chainmail_helmet": "linsi badmapku",
  "item.minecraft.chainmail_leggings": "linsi badypalku",
  "item.minecraft.charcoal": "fagytabno",
  "item.minecraft.cherry_boat": "ricrceraso bloti",
  "item.minecraft.cherry_chest_boat": "ricrceraso bloti joi vasru",
  "item.minecraft.chest_minecart": "baktu trene joi vasru",
  "item.minecraft.chicken": "nalseljukpa jipcyre'u",
  "item.minecraft.chicken_spawn_egg": "jipci jbeso'a",
  "item.minecraft.chorus_fruit": "girza'a grute",
  "item.minecraft.clay_ball": "kityboi",
  "item.minecraft.clock": "junla",
  "item.minecraft.coal": "kolme",
  "item.minecraft.coast_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "cakla dembi",
  "item.minecraft.cod": "fiprgadusu",
  "item.minecraft.cod_bucket": "fiprgadusu baktu",
  "item.minecraft.cod_spawn_egg": "fiprgadusu jbeso'a",
  "item.minecraft.command_block_minecart": "trene joi ziltinbe bliku",
  "item.minecraft.compass": "makfartci",
  "item.minecraft.cooked_beef": "seljukpa bakre'u",
  "item.minecraft.cooked_chicken": "seljukpa jipcyre'u",
  "item.minecraft.cooked_cod": "seljukpa fiprgadusu",
  "item.minecraft.cooked_mutton": "seljukpa lanre'u",
  "item.minecraft.cooked_porkchop": "seljukpa xajre'u",
  "item.minecraft.cooked_rabbit": "seljukpa ractu",
  "item.minecraft.cooked_salmon": "seljukpa salmone",
  "item.minecraft.cookie": "cmalu titnanba",
  "item.minecraft.copper_axe": "tunka ka'amru",
  "item.minecraft.copper_boots": "tunka cutci",
  "item.minecraft.copper_chestplate": "tunka creka",
  "item.minecraft.copper_golem_spawn_egg": "tunka remsmimi'i jbeso'a",
  "item.minecraft.copper_helmet": "tunka mapku",
  "item.minecraft.copper_hoe": "tunka lixtci",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "tunka tanbo",
  "item.minecraft.copper_leggings": "tunka palku",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "tunka tunmru",
  "item.minecraft.copper_shovel": "tunka canpa",
  "item.minecraft.copper_spear": "tunka kilga'axa'i",
  "item.minecraft.copper_sword": "tunka cladaxi",
  "item.minecraft.cow_spawn_egg": "bakni jbeso'a",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "terlanci",
  "item.minecraft.creeper_banner_pattern.desc": "ri'orfrupo'a flira",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "jbeso'a be la kriper.",
  "item.minecraft.crossbow": "seljicyce'a",
  "item.minecraft.crossbow.projectile": "selce'a:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "cicna bafydakli",
  "item.minecraft.cyan_dye": "cicna xinmo",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "ckape ke staku selpo'i",
  "item.minecraft.dark_oak_boat": "mancindu bloti",
  "item.minecraft.dark_oak_chest_boat": "mancindu bloti joi vasru",
  "item.minecraft.debug_stick": "gafygaurga'a",
  "item.minecraft.debug_stick.empty": "%s has no properties",
  "item.minecraft.debug_stick.select": "selected \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" to %s",
  "item.minecraft.diamond": "tabjme",
  "item.minecraft.diamond_axe": "tabjme ka'amru",
  "item.minecraft.diamond_boots": "tabjme cutci",
  "item.minecraft.diamond_chestplate": "tabjme creka",
  "item.minecraft.diamond_helmet": "tabjme mapku",
  "item.minecraft.diamond_hoe": "tabjme terplixa",
  "item.minecraft.diamond_horse_armor": "tabjme xirbadycalku",
  "item.minecraft.diamond_leggings": "tabjme palku",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "tabjme tunmru",
  "item.minecraft.diamond_shovel": "tabjme canpa",
  "item.minecraft.diamond_spear": "tabjme kilga'axa'i",
  "item.minecraft.diamond_sword": "tabjme cladaxi",
  "item.minecraft.disc_fragment_5": "lo spisa jinplita",
  "item.minecraft.disc_fragment_5.desc": "Music Disc - 5",
  "item.minecraft.dolphin_spawn_egg": "delfinu jbeso'a",
  "item.minecraft.donkey_spawn_egg": "xasli jbeso'a",
  "item.minecraft.dragon_breath": "drakono selva'u ",
  "item.minecraft.dried_kelp": "se sudgau vraike",
  "item.minecraft.drowned_spawn_egg": "djacu mivmro jbeso'a",
  "item.minecraft.dune_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "mirsna selpo'i",
  "item.minecraft.egg": "sovda",
  "item.minecraft.elder_guardian_spawn_egg": "dzebadypre jbeso'a",
  "item.minecraft.elytra": "na'irnelitrono",
  "item.minecraft.emerald": "ri'ojme",
  "item.minecraft.enchanted_book": "mafcku",
  "item.minecraft.enchanted_golden_apple": "selmafyze'a sloplise",
  "item.minecraft.end_crystal": ".endre krili",
  "item.minecraft.ender_dragon_spawn_egg": "me la .endr. drakono jbeso'a",
  "item.minecraft.ender_eye": ".endre kanla",
  "item.minecraft.ender_pearl": ".endre boijme",
  "item.minecraft.enderman_spawn_egg": ".endre prenu jbeso'a",
  "item.minecraft.endermite_spawn_egg": ".endre miptera jbeso'a",
  "item.minecraft.evoker_spawn_egg": "pacykemklacpepre jbeso'a",
  "item.minecraft.experience_bottle": "makfa botpi",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "tumfakli'u ke staku selpo'i",
  "item.minecraft.eye_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "pimlu",
  "item.minecraft.fermented_spider_eye": "fusra ke jukni kanla",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "cartu",
  "item.minecraft.fire_charge": "mafselfagri",
  "item.minecraft.firework_rocket": "mlefagri jakne",
  "item.minecraft.firework_rocket.flight": "vofli snidu li",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "spoja tarmi fa",
  "item.minecraft.firework_star.black": "xekri",
  "item.minecraft.firework_star.blue": "blanu",
  "item.minecraft.firework_star.brown": "bunre",
  "item.minecraft.firework_star.custom_color": "Custom",
  "item.minecraft.firework_star.cyan": "cicna",
  "item.minecraft.firework_star.fade_to": "se binxo skari fa",
  "item.minecraft.firework_star.flicker": "camsuksa",
  "item.minecraft.firework_star.gray": "grusi",
  "item.minecraft.firework_star.green": "crino",
  "item.minecraft.firework_star.light_blue": "labybla",
  "item.minecraft.firework_star.light_gray": "labgrusi",
  "item.minecraft.firework_star.lime": "labri'o",
  "item.minecraft.firework_star.magenta": "nukni",
  "item.minecraft.firework_star.orange": "narju",
  "item.minecraft.firework_star.pink": "labnukni",
  "item.minecraft.firework_star.purple": "zirpu",
  "item.minecraft.firework_star.red": "xunre",
  "item.minecraft.firework_star.shape": "lo nalsau",
  "item.minecraft.firework_star.shape.burst": "lo sukpo'a",
  "item.minecraft.firework_star.shape.creeper": "la .kripr.",
  "item.minecraft.firework_star.shape.large_ball": "barda bolci",
  "item.minecraft.firework_star.shape.small_ball": "cmalu bolci",
  "item.minecraft.firework_star.shape.star": "lo jinda",
  "item.minecraft.firework_star.trail": "te camlu'a",
  "item.minecraft.firework_star.white": "blabi",
  "item.minecraft.firework_star.yellow": "pelxu",
  "item.minecraft.fishing_rod": "fipkalte grana",
  "item.minecraft.flint": "fagro'i",
  "item.minecraft.flint_and_steel": "fagrokci joi gasta",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "sarlu",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Banner Pattern",
  "item.minecraft.flower_banner_pattern.desc": "xrula tarmi",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "xrula patxu",
  "item.minecraft.fox_spawn_egg": "lorxu jbeso'a",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "pendo ke staku selpo'i",
  "item.minecraft.frog_spawn_egg": "pipybanfi jbeso'a",
  "item.minecraft.furnace_minecart": "trene joi toknu",
  "item.minecraft.ghast_spawn_egg": "jbeso'a be la gast.",
  "item.minecraft.ghast_tear": "la me gast. selklaku",
  "item.minecraft.glass_bottle": "blaci botpi",
  "item.minecraft.glistering_melon_slice": "mircai zmepa'o",
  "item.minecraft.globe_banner_pattern": "Banner Pattern",
  "item.minecraft.globe_banner_pattern.desc": "boltai",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "carmi jbari",
  "item.minecraft.glow_ink_sac": "carmi ke xinmo dakli",
  "item.minecraft.glow_item_frame": "carmi ke ja'ordai greku",
  "item.minecraft.glow_squid_spawn_egg": "carmi kalmari jbeso'a",
  "item.minecraft.glowstone_dust": "gusyblaci purmo",
  "item.minecraft.goat_horn": "kanba tabryjirna",
  "item.minecraft.goat_spawn_egg": "kanba jbeso'a",
  "item.minecraft.gold_ingot": "solji tanbo",
  "item.minecraft.gold_nugget": "solji spisa",
  "item.minecraft.golden_apple": "solji plise",
  "item.minecraft.golden_axe": "solji ka'amru",
  "item.minecraft.golden_boots": "solji cutci",
  "item.minecraft.golden_carrot": "solji najgenja",
  "item.minecraft.golden_chestplate": "solji creka",
  "item.minecraft.golden_helmet": "solji mapku",
  "item.minecraft.golden_hoe": "solji terplixa",
  "item.minecraft.golden_horse_armor": "solji xirbadycalku",
  "item.minecraft.golden_leggings": "solji palku",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "solji tunmru",
  "item.minecraft.golden_shovel": "solji canpa",
  "item.minecraft.golden_spear": "solji kilga'axa'i",
  "item.minecraft.golden_sword": "solji cladaxi",
  "item.minecraft.gray_bundle": "grusi bafydakli",
  "item.minecraft.gray_dye": "grusi xinmo",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "crino bafydakli",
  "item.minecraft.green_dye": "crino xinmo",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "badypre jbeso'a",
  "item.minecraft.gunpowder": "bampu'o",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "bifyda'u tarmi",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "lo xamsi pruxi",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "cnise'i ke staku selpo'i",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "dunku ke staku selpo'i",
  "item.minecraft.hoglin_spawn_egg": "balxarju jbeso'a",
  "item.minecraft.honey_bottle": "bicydja botpi",
  "item.minecraft.honeycomb": "biclakse",
  "item.minecraft.hopper_minecart": "trene joi tansi",
  "item.minecraft.horse_spawn_egg": "xirma jbeso'a",
  "item.minecraft.host_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "gerki'a ke staku selpo'i",
  "item.minecraft.husk_spawn_egg": "sudga mivmro jbeso'a",
  "item.minecraft.ink_sac": "xinmo dakli",
  "item.minecraft.iron_axe": "tirse ka'amru",
  "item.minecraft.iron_boots": "tirse cutci",
  "item.minecraft.iron_chestplate": "tirse creka",
  "item.minecraft.iron_golem_spawn_egg": "tirse remsmimi'i jbeso'a",
  "item.minecraft.iron_helmet": "tirse mapku",
  "item.minecraft.iron_hoe": "tirse terplixa",
  "item.minecraft.iron_horse_armor": "tirse xirbadycalku",
  "item.minecraft.iron_ingot": "tirse tanbo",
  "item.minecraft.iron_leggings": "tirse palku",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "tirse spisa",
  "item.minecraft.iron_pickaxe": "tirse tunmru",
  "item.minecraft.iron_shovel": "tirse canpa",
  "item.minecraft.iron_spear": "tirse kilga'axa'i",
  "item.minecraft.iron_sword": "tirse cladaxi",
  "item.minecraft.item_frame": "ja'ordai greku",
  "item.minecraft.jungle_boat": "cicricfoi bloti",
  "item.minecraft.jungle_chest_boat": "cicricfoi bloti joi vasru",
  "item.minecraft.knowledge_book": "selju'o cukta",
  "item.minecraft.lapis_lazuli": "blaro'i",
  "item.minecraft.lava_bucket": "likro'i baktu",
  "item.minecraft.lead": "velxlu",
  "item.minecraft.leather": "bakskapi",
  "item.minecraft.leather_boots": "bakskapi cutci",
  "item.minecraft.leather_chestplate": "bakskapi creka",
  "item.minecraft.leather_helmet": "bakskapi mapku",
  "item.minecraft.leather_horse_armor": "bakskapi ke xirma dabycalku",
  "item.minecraft.leather_leggings": "bakskapi palku",
  "item.minecraft.light_blue_bundle": "labybla bafydakli",
  "item.minecraft.light_blue_dye": "labybla xinmo",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "labgrusi bafydakli",
  "item.minecraft.light_gray_dye": "labygrusi xinmo",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "labri'o bafydakli",
  "item.minecraft.lime_dye": "pelri'o xinmo",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "mafsodva mau'ufri",
  "item.minecraft.lingering_potion.effect.awkward": "Awkward Lingering Potion",
  "item.minecraft.lingering_potion.effect.empty": "Lingering Uncraftable Potion",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Lingering Potion of Fire Resistance",
  "item.minecraft.lingering_potion.effect.harming": "Lingering Potion of Harming",
  "item.minecraft.lingering_potion.effect.healing": "Lingering Potion of Healing",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Lingering Potion of Invisibility",
  "item.minecraft.lingering_potion.effect.leaping": "Lingering Potion of Leaping",
  "item.minecraft.lingering_potion.effect.levitation": "Lingering Potion of Levitation",
  "item.minecraft.lingering_potion.effect.luck": "Lingering Potion of Luck",
  "item.minecraft.lingering_potion.effect.mundane": "Mundane Lingering Potion",
  "item.minecraft.lingering_potion.effect.night_vision": "Lingering Potion of Night Vision",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Lingering Potion of Poison",
  "item.minecraft.lingering_potion.effect.regeneration": "Lingering Potion of Regeneration",
  "item.minecraft.lingering_potion.effect.slow_falling": "Lingering Potion of Slow Falling",
  "item.minecraft.lingering_potion.effect.slowness": "Lingering Potion of Slowness",
  "item.minecraft.lingering_potion.effect.strength": "Lingering Potion of Strength",
  "item.minecraft.lingering_potion.effect.swiftness": "Lingering Potion of Swiftness",
  "item.minecraft.lingering_potion.effect.thick": "Thick Lingering Potion",
  "item.minecraft.lingering_potion.effect.turtle_master": "Lingering Potion of the Turtle Master",
  "item.minecraft.lingering_potion.effect.water": "Lingering Water Bottle",
  "item.minecraft.lingering_potion.effect.water_breathing": "Lingering Potion of Water Breathing",
  "item.minecraft.lingering_potion.effect.weakness": "Lingering Potion of Weakness",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "tcokumte jbeso'a",
  "item.minecraft.lodestone_compass": "maksi fartci",
  "item.minecraft.mace": "bolga'axa'i",
  "item.minecraft.magenta_bundle": "nukni bafydakli",
  "item.minecraft.magenta_dye": "nukni xinmo",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "likro'i kruji",
  "item.minecraft.magma_cube_spawn_egg": "likro'i bliku jbeso'a",
  "item.minecraft.mangrove_boat": "jiryricfoi bloti",
  "item.minecraft.mangrove_chest_boat": "jiryricfoi bloti joi vasru",
  "item.minecraft.map": "kunti cartu",
  "item.minecraft.melon_seeds": "guzme tsiju",
  "item.minecraft.melon_slice": "guzme panlo",
  "item.minecraft.milk_bucket": "ladru baktu",
  "item.minecraft.minecart": "baktu trene",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "kunkakpa ke staku selpo'i",
  "item.minecraft.mojang_banner_pattern": "Banner Pattern",
  "item.minecraft.mojang_banner_pattern.desc": "zo'e",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "bakygumri jbeso'a",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "mrodri ke staku selpo'i",
  "item.minecraft.mule_spawn_egg": "xaslyxi'a jbeso'a",
  "item.minecraft.mushroom_stew": "gumri stasu",
  "item.minecraft.music_disc_11": "zgike vreji",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "zgike vreji",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "zgike vreji",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "zgike vreji",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "zgike vreji",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "zgike vreji",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "zgike vreji",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "lo zgike vreji",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "zgike vreji",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "zgike vreji",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "zgike vreji",
  "item.minecraft.music_disc_otherside.desc": "la'o lena raine. ragve",
  "item.minecraft.music_disc_pigstep": "zgike vreji",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "zgike vreji",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "zgike vreji",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "zgike vreji",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "zgike vreji",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "zgike vreji",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "nalseljukpa lanr'eu",
  "item.minecraft.name_tag": "cmene tcita",
  "item.minecraft.nautilus_shell": "cakyjaktu calku",
  "item.minecraft.nautilus_spawn_egg": "cakyjaktu jbeso'a",
  "item.minecraft.nether_brick": "la me neter. kitybli",
  "item.minecraft.nether_star": "la me neter. tarci",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "dzimujyjinme ka'amru",
  "item.minecraft.netherite_boots": "dzimujyjinme cutci",
  "item.minecraft.netherite_chestplate": "dzimujyjinme creka",
  "item.minecraft.netherite_helmet": "dzimujyjinme mapku",
  "item.minecraft.netherite_hoe": "dzimujyjinme lixtci",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "dzimujyjinme kubli",
  "item.minecraft.netherite_leggings": "dzimujyjinme palku",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "dzimujyjinme tunmru",
  "item.minecraft.netherite_scrap": "dzimujyjinme spisa",
  "item.minecraft.netherite_shovel": "dzimujyjinme canpa",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "dzimujyjinme cladaxi",
  "item.minecraft.netherite_upgrade_smithing_template": "jimyzbatermo'a",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "cindu bloti",
  "item.minecraft.oak_chest_boat": "cindu bloti joi vasru",
  "item.minecraft.ocelot_spawn_egg": "cicmlatu jbeso'a",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "selte'a ke talsa ckiku",
  "item.minecraft.orange_bundle": "narju bafydakli",
  "item.minecraft.orange_dye": "narju xinmo",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "pixra",
  "item.minecraft.pale_oak_boat": "kadycindu bloti",
  "item.minecraft.pale_oak_chest_boat": "kadycindu bloti joi vasru",
  "item.minecraft.panda_spawn_egg": "latcribe jbeso'a",
  "item.minecraft.paper": "pelji",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "spitaki jbeso'a",
  "item.minecraft.phantom_membrane": "cteru'i nalci",
  "item.minecraft.phantom_spawn_egg": "cteru'i jbeso'a",
  "item.minecraft.pig_spawn_egg": "xarju jbeso'a",
  "item.minecraft.piglin_banner_pattern": "Banner Pattern",
  "item.minecraft.piglin_banner_pattern.desc": "xajyzbi",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "cilce xajypre jbeso'a",
  "item.minecraft.piglin_spawn_egg": "xajypre jbeso'a",
  "item.minecraft.pillager_spawn_egg": "vilcpapre jbeso'a",
  "item.minecraft.pink_bundle": "penka bafydakli",
  "item.minecraft.pink_dye": "labnukni",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "paxspa",
  "item.minecraft.pitcher_pod": "paxspa tsiju",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "kamcfu ke staku selpo'i",
  "item.minecraft.poisonous_potato": "vindu patlu",
  "item.minecraft.polar_bear_spawn_egg": "bercribe jbeso'a",
  "item.minecraft.popped_chorus_fruit": "selpo'i girza'a grute",
  "item.minecraft.porkchop": "nalseljukpa xajre'u",
  "item.minecraft.potato": "patlu",
  "item.minecraft.potion": "mafsodva",
  "item.minecraft.potion.effect.awkward": "nalpa'e mafsodva",
  "item.minecraft.potion.effect.empty": "nalzbaka'e mafsodva",
  "item.minecraft.potion.effect.fire_resistance": "fagri xarnu mafsodva",
  "item.minecraft.potion.effect.harming": "xrani mafsodva",
  "item.minecraft.potion.effect.healing": "kanro mafsodva",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "selvisnalka'e mafsodva",
  "item.minecraft.potion.effect.leaping": "plipe mafsodva",
  "item.minecraft.potion.effect.levitation": "fulta mafsodva",
  "item.minecraft.potion.effect.luck": "funca mafsodva",
  "item.minecraft.potion.effect.mundane": "fadni mafsodva",
  "item.minecraft.potion.effect.night_vision": "ctecpi mafsodva",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "vindu mafsodva",
  "item.minecraft.potion.effect.regeneration": "ka'orbi'o mafsodva",
  "item.minecraft.potion.effect.slow_falling": "snofa'u mafsodva",
  "item.minecraft.potion.effect.slowness": "masno mafsodva",
  "item.minecraft.potion.effect.strength": "tsali mafsodva",
  "item.minecraft.potion.effect.swiftness": "klama sutra mafsodva",
  "item.minecraft.potion.effect.thick": "rotsu mafsodva",
  "item.minecraft.potion.effect.turtle_master": "cakrespycei mafsodva",
  "item.minecraft.potion.effect.water": "djacu botpi",
  "item.minecraft.potion.effect.water_breathing": "finpe mafsodva",
  "item.minecraft.potion.effect.weakness": "ruble mafsodva",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "baktu be lo pumsi'e",
  "item.minecraft.prismarine_crystals": "prismarine krili",
  "item.minecraft.prismarine_shard": "prismarine selpo'i",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "selji'a ke staku selpo'i",
  "item.minecraft.pufferfish": "finprtetraodontidi",
  "item.minecraft.pufferfish_bucket": "fiprtetraudontidi baktu",
  "item.minecraft.pufferfish_spawn_egg": "fiprtetraudontidi jbeso'a",
  "item.minecraft.pumpkin_pie": "guzmrkukurbita nabypalne",
  "item.minecraft.pumpkin_seeds": "guzmrkukurbita tsiju",
  "item.minecraft.purple_bundle": "zirpu bafydakli",
  "item.minecraft.purple_dye": "zirpu xinmo",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "krilrkartso",
  "item.minecraft.rabbit": "nalseljukpa ractu",
  "item.minecraft.rabbit_foot": "jamfu be lo ractu",
  "item.minecraft.rabbit_hide": "skapi be lo ractu",
  "item.minecraft.rabbit_spawn_egg": "ratcu jbeso'a",
  "item.minecraft.rabbit_stew": "ractu stasu",
  "item.minecraft.raiser_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "nunspokezgau jbeso'a",
  "item.minecraft.raw_copper": "nalselrucyzu'e tunka",
  "item.minecraft.raw_gold": "nalselrucyzu'e solji",
  "item.minecraft.raw_iron": "nalselrucyzu'e tirse",
  "item.minecraft.recovery_compass": "jajgauxru makfartci",
  "item.minecraft.red_bundle": "xunre bafydakli",
  "item.minecraft.red_dye": "xunre xinmo",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "me la redston. pulce",
  "item.minecraft.resin_brick": "gomja kubli",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "fusra rectu",
  "item.minecraft.saddle": "danlu seltse",
  "item.minecraft.salmon": "nalseljukpa salmone",
  "item.minecraft.salmon_bucket": "salmone baktu",
  "item.minecraft.salmon_spawn_egg": "salmone jbeso'a",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "bakfu ke staku selpo'i",
  "item.minecraft.shears": "jinci",
  "item.minecraft.sheep_spawn_egg": "lanme jbeso'a",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "marbi ke staku selpo'i",
  "item.minecraft.shield": "badgai",
  "item.minecraft.shield.black": "xekri badgai",
  "item.minecraft.shield.blue": "blanu badgai",
  "item.minecraft.shield.brown": "bunre badgai",
  "item.minecraft.shield.cyan": "cicna badgai",
  "item.minecraft.shield.gray": "grusi badgai",
  "item.minecraft.shield.green": "crino badgai",
  "item.minecraft.shield.light_blue": "labybla badgai",
  "item.minecraft.shield.light_gray": "labgrusi badgai",
  "item.minecraft.shield.lime": "labri'o badgai",
  "item.minecraft.shield.magenta": "nukni badgai",
  "item.minecraft.shield.orange": "narju badgai",
  "item.minecraft.shield.pink": "penka badgai",
  "item.minecraft.shield.purple": "zirpu badgai",
  "item.minecraft.shield.red": "xunre badgai",
  "item.minecraft.shield.white": "blabi badgai",
  "item.minecraft.shield.yellow": "pelxu badgai",
  "item.minecraft.shulker_shell": "calku pe la cylkr.",
  "item.minecraft.shulker_spawn_egg": "jbeso'a be la cylkr.",
  "item.minecraft.sign": "Sign",
  "item.minecraft.silence_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "selmipyda'u jbeso'a",
  "item.minecraft.skeleton_horse_spawn_egg": "bogrekyxirma jbeso'a",
  "item.minecraft.skeleton_spawn_egg": "bogygreku jbeso'a",
  "item.minecraft.skull_banner_pattern": "Banner Pattern",
  "item.minecraft.skull_banner_pattern.desc": "sedbo'u tarmi",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "sedbo'u ke staku selpo'i",
  "item.minecraft.slime_ball": "jduboi",
  "item.minecraft.slime_spawn_egg": "jduda'u jbeso'a",
  "item.minecraft.smithing_template": "jimyzbatermo'a",
  "item.minecraft.smithing_template.applies_to": "Applies to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Add ingot or crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armor",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Add a piece of armor",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Crystals",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Add Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond Equipment",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add diamond armor, weapon, or tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Upgrade: ",
  "item.minecraft.sniffer_spawn_egg": "zbisakci jbeso'a",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "zbisakci ke staku selpo'i",
  "item.minecraft.snout_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "snime remsmimi'i jbeso'a",
  "item.minecraft.snowball": "snime bolci",
  "item.minecraft.spectral_arrow": "Spectral Arrow",
  "item.minecraft.spider_eye": "jukni kanla",
  "item.minecraft.spider_spawn_egg": "jukni jbeso'a",
  "item.minecraft.spire_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "selre'o mafsodva",
  "item.minecraft.splash_potion.effect.awkward": "nalpa'e ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.empty": "nalzbaka'e ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.fire_resistance": "nunfagyxarnu ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.harming": "nunxai ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.healing": "nunka'o ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "nunselvisnalka'e ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.leaping": "nunpi'e ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.levitation": "fulta ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.luck": "funca ke mafsodva mafsodva",
  "item.minecraft.splash_potion.effect.mundane": "fadni ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.night_vision": "nunmanvi'a selre'o mafsodva",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "vindu ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.regeneration": "nunka'orbi'o ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.slow_falling": "nunsnofa'u ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.slowness": "nunklasno ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.strength": "nuntsa ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.swiftness": "nunklasutra ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.thick": "rotsu ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.turtle_master": "selre'o ke cakrespycei mafsodva",
  "item.minecraft.splash_potion.effect.water": "selre'o jacybo'i",
  "item.minecraft.splash_potion.effect.water_breathing": "nunjaurjirva'u ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.weakness": "ruble ke selre'o mafsodva",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "ckunu bloti",
  "item.minecraft.spruce_chest_boat": "ckunu bloti joi vasru",
  "item.minecraft.spyglass": "zgablaci",
  "item.minecraft.squid_spawn_egg": "kalmari jbeso'a",
  "item.minecraft.stick": "grana",
  "item.minecraft.stone_axe": "rokci ka'amru",
  "item.minecraft.stone_hoe": "rokci terplixa",
  "item.minecraft.stone_pickaxe": "rokci tunmru",
  "item.minecraft.stone_shovel": "rokci canpa",
  "item.minecraft.stone_spear": "rokci kilga'axa'i",
  "item.minecraft.stone_sword": "rokci cladaxi",
  "item.minecraft.stray_spawn_egg": "muvzva jbeso'a",
  "item.minecraft.strider_spawn_egg": "fagdzu jbeso'a",
  "item.minecraft.string": "skori",
  "item.minecraft.sugar": "sakta",
  "item.minecraft.suspicious_stew": "selsenpi stasu",
  "item.minecraft.sweet_berries": "titla jbari",
  "item.minecraft.tadpole_bucket": "verbanfi baktu",
  "item.minecraft.tadpole_spawn_egg": "lo verbanfi jbeso'a",
  "item.minecraft.tide_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "makfa calga'a",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "Uncraftable Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "fagyxarnu celga'a",
  "item.minecraft.tipped_arrow.effect.harming": "xrani celga'a",
  "item.minecraft.tipped_arrow.effect.healing": "kanro celga'a",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "selvisnalka'e celga'a",
  "item.minecraft.tipped_arrow.effect.leaping": "plipe celga'a",
  "item.minecraft.tipped_arrow.effect.levitation": "fulta celga'a",
  "item.minecraft.tipped_arrow.effect.luck": "funca celga'a",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "manvi'a celga'a",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "vindu celga'a",
  "item.minecraft.tipped_arrow.effect.regeneration": "ka'orbi'o celga'a",
  "item.minecraft.tipped_arrow.effect.slow_falling": "snofa'u celga'a",
  "item.minecraft.tipped_arrow.effect.slowness": "klasno celga'a",
  "item.minecraft.tipped_arrow.effect.strength": "tsali celga'a",
  "item.minecraft.tipped_arrow.effect.swiftness": "klasutra celga'a",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.turtle_master": "cakrespycei celga'a",
  "item.minecraft.tipped_arrow.effect.water": "sploici celga'a",
  "item.minecraft.tipped_arrow.effect.water_breathing": "jaurjirva'u celga'a",
  "item.minecraft.tipped_arrow.effect.weakness": "ruble celga'a",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "baktu trene joi jbama",
  "item.minecraft.torchflower_seeds": "fagytergusxrula tsiju",
  "item.minecraft.totem_of_undying": "nalmro nindode",
  "item.minecraft.trader_llama_spawn_egg": "canja tcokumte jbeso'a",
  "item.minecraft.trial_key": "talsa ckiku",
  "item.minecraft.trident": "cibyba'erxa'i",
  "item.minecraft.tropical_fish": "tropika finpe",
  "item.minecraft.tropical_fish_bucket": "tropika finpe baktu",
  "item.minecraft.tropical_fish_spawn_egg": "tropika finpe jbeso'a",
  "item.minecraft.turtle_helmet": "cakyrespa calku",
  "item.minecraft.turtle_scute": "cakyrespa piltapla",
  "item.minecraft.turtle_spawn_egg": "cakyrespa jbeso'a",
  "item.minecraft.vex_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "cmapalci jbeso'a",
  "item.minecraft.villager_spawn_egg": "selsosyzda jbeso'a",
  "item.minecraft.vindicator_spawn_egg": "pacybandu jbeso'a",
  "item.minecraft.wandering_trader_spawn_egg": "litru canja jbeso'a",
  "item.minecraft.ward_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "le visnalka'e cizda'u jbeso'a",
  "item.minecraft.warped_fungus_on_a_stick": "cizra bo gumri joi grana",
  "item.minecraft.water_bucket": "djacu baktu",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "maxri",
  "item.minecraft.wheat_seeds": "maxri tsiju",
  "item.minecraft.white_bundle": "blabi bafydakli",
  "item.minecraft.white_dye": "blabi xinmo",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "jimyzbatermo'a",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "termafyfe'i jbeso'a",
  "item.minecraft.wither_skeleton_spawn_egg": "me la .uiter. bogygreku jbeso'a",
  "item.minecraft.wither_spawn_egg": "jbeso'a be la .uidr.",
  "item.minecraft.wolf_armor": "labnybadycalku",
  "item.minecraft.wolf_spawn_egg": "labno jbeso'a",
  "item.minecraft.wooden_axe": "mudri ka'amru",
  "item.minecraft.wooden_hoe": "mudri terplixa",
  "item.minecraft.wooden_pickaxe": "mudri tunmru",
  "item.minecraft.wooden_shovel": "mudri canpa",
  "item.minecraft.wooden_spear": "mudri kilga'axa'i",
  "item.minecraft.wooden_sword": "mudri cladaxi",
  "item.minecraft.writable_book": "penbi joi cukta",
  "item.minecraft.written_book": "fanmo cukta",
  "item.minecraft.yellow_bundle": "pelxu bafydakli",
  "item.minecraft.yellow_dye": "pelxu xinmo",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "mivmro balxarju jbeso'a",
  "item.minecraft.zombie_horse_spawn_egg": "mivmro xirma jbeso'a",
  "item.minecraft.zombie_nautilus_spawn_egg": "mivmro cakyjaktu jbeso'a",
  "item.minecraft.zombie_spawn_egg": "mivmro jbeso'a",
  "item.minecraft.zombie_villager_spawn_egg": "mivmro selsosyzda jbeso'a",
  "item.minecraft.zombified_piglin_spawn_egg": "mivmro xajypre jbeso'a"
}
export const jbo_en = items; 
